// Shopify cart / variant integration (prepended to lc-label-customizer.js)

document.addEventListener('DOMContentLoaded', function () {



  var lcQuantityId = (typeof window.lcQuantityInputId === 'string') ? window.lcQuantityInputId : 'quantity';



  function getQuantityInput() { return document.getElementById(lcQuantityId); }



  function lcCartStr(key, fallback) {

    if (typeof window.lcStr === 'function') return window.lcStr(key, fallback);

    return fallback;

  }



  function lcCartConfirmEnabled() {

    if (window.lcSkipCartConfirm === true) return false;

    if (window.lcConfirmBeforeCart === false) return false;

    return true;

  }



  function lcCartConfirmSummaryLines(props) {

    var lines = [];

    if (!props || typeof props !== 'object') return lines;

    Object.keys(props).forEach(function (k) {

      if (!k || k.charAt(0) === '_') return;

      var v = props[k];

      if (v == null || String(v).trim() === '') return;

      lines.push({ label: k, value: String(v) });

    });

    return lines;

  }



  function ensureCartConfirmModal() {

    var root = document.getElementById('lc-cart-confirm');

    if (root) return root;



    root = document.createElement('div');

    root.id = 'lc-cart-confirm';

    root.className = 'lc-cart-confirm';

    root.hidden = true;

    root.setAttribute('role', 'dialog');

    root.setAttribute('aria-modal', 'true');

    root.innerHTML =

      '<div class="lc-cart-confirm__backdrop" data-lc-cart-confirm-dismiss aria-hidden="true">&nbsp;</div>' +

      '<div class="lc-cart-confirm__panel">' +

      '<button type="button" class="lc-cart-confirm__close" data-lc-cart-confirm-dismiss aria-label="">&times;</button>' +

      '<h2 class="lc-cart-confirm__title"></h2>' +

      '<p class="lc-cart-confirm__lead"></p>' +

      '<div class="lc-cart-confirm__preview">' +

      '<p class="lc-cart-confirm__loading"></p>' +

      '<img class="lc-cart-confirm__img" alt="" />' +

      '</div>' +

      '<ul class="lc-cart-confirm__summary"></ul>' +

      '<div class="lc-cart-confirm__actions">' +

      '<button type="button" class="lc-cart-confirm__cancel"></button>' +

      '<button type="button" class="lc-cart-confirm__ok"></button>' +

      '</div>' +

      '</div>';



    document.body.appendChild(root);



    var closeLabel = lcCartStr('cartConfirmClose', 'Fermer');

    root.querySelector('.lc-cart-confirm__close').setAttribute('aria-label', closeLabel);



    return root;

  }



  function lcApplyCartConfirmCopy(modal) {

    modal.querySelector('.lc-cart-confirm__title').textContent = lcCartStr(

      'cartConfirmTitle',

      'Confirmer votre étiquette'

    );

    modal.querySelector('.lc-cart-confirm__lead').textContent = lcCartStr(

      'cartConfirmLead',

      'Vérifiez l\'aperçu avant d\'ajouter au panier.'

    );

    modal.querySelector('.lc-cart-confirm__loading').textContent = lcCartStr(

      'cartConfirmLoading',

      'Préparation de l\'aperçu…'

    );

    modal.querySelector('.lc-cart-confirm__cancel').textContent = lcCartStr(

      'cartConfirmCancel',

      'Modifier'

    );

    modal.querySelector('.lc-cart-confirm__ok').textContent = lcCartStr(

      'cartConfirmOk',

      'Confirmer et ajouter'

    );

  }



  function lcOpenCartConfirmModal(previewPromise, props) {

    return new Promise(function (resolve) {

      var modal = ensureCartConfirmModal();

      lcApplyCartConfirmCopy(modal);

      var img = modal.querySelector('.lc-cart-confirm__img');

      var loading = modal.querySelector('.lc-cart-confirm__loading');

      var summary = modal.querySelector('.lc-cart-confirm__summary');

      var okBtn = modal.querySelector('.lc-cart-confirm__ok');

      var settled = false;



      function finish(result) {

        if (settled) return;

        settled = true;

        modal.hidden = true;

        document.body.classList.remove('lc-cart-confirm-open');

        document.removeEventListener('keydown', onKey);

        resolve(result);

      }



      function onKey(e) {

        if (e.key === 'Escape') finish(false);

      }



      summary.innerHTML = '';

      lcCartConfirmSummaryLines(props).forEach(function (line) {
        var li = document.createElement('li');
        var kSpan = document.createElement('span');
        kSpan.className = 'lc-cart-confirm__summary-k';
        kSpan.textContent = line.label;
        var vSpan = document.createElement('span');
        vSpan.className = 'lc-cart-confirm__summary-v';
        vSpan.textContent = line.value;
        li.appendChild(kSpan);
        li.appendChild(document.createTextNode(' '));
        li.appendChild(vSpan);
        summary.appendChild(li);
      });



      img.removeAttribute('src');

      img.hidden = true;

      loading.hidden = false;

      okBtn.disabled = true;



      modal.hidden = false;

      document.body.classList.add('lc-cart-confirm-open');

      document.addEventListener('keydown', onKey);



      modal.querySelectorAll('[data-lc-cart-confirm-dismiss]').forEach(function (el) {

        el.onclick = function () { finish(false); };

      });

      modal.querySelector('.lc-cart-confirm__cancel').onclick = function () { finish(false); };

      okBtn.onclick = function () { finish(true); };



      previewPromise.then(function (url) {

        loading.hidden = true;

        if (url) {

          img.src = url;

          img.hidden = false;

        }

        okBtn.disabled = false;

        okBtn.focus();

      }).catch(function () {

        loading.hidden = true;

        okBtn.disabled = false;

        okBtn.focus();

      });

    });

  }



  function runShopifyCartAdd(ctx) {

    ctx = ctx || {};

    var addBtn = ctx.addBtn;

    var variant = ctx.variant;

    var variantId = ctx.variantId || (variant && variant.id);

    var qty = parseInt(ctx.quantity, 10) || 1;

    var props = ctx.props || {};

    var canvas = ctx.canvas;



    if (!variantId) return;



    function lcFinalizeCartPreviewProps(cartProps) {

      var compress = window.lcCompressPreviewDataUrlForCart;

      if (typeof compress !== 'function') return Promise.resolve(cartProps);

      var previewKey = window.LC_CART_PREVIEW_KEY || '_LC Preview';

      var previewImage = cartProps[previewKey] || '';

      if (!previewImage) return Promise.resolve(cartProps);

      return compress(previewImage).then(function (compressed) {

        if (compressed) {
          cartProps[previewKey] = compressed;
          return cartProps;
        }
        if (previewImage.indexOf('data:image') === 0 && previewImage.length > (window.LC_CART_PREVIEW_MAX_CHARS || 4800)) {
          return compress(previewImage, 3200).then(function (smaller) {
            if (smaller) cartProps[previewKey] = smaller;
            return cartProps;
          });
        }
        if (previewImage.indexOf('http') === 0) cartProps[previewKey] = previewImage;
        return cartProps;

      });

    }



    function performAdd() {

      var attachPreview = (typeof window.lcAttachCartPreview === 'function')

        ? window.lcAttachCartPreview(props, canvas)

        : Promise.resolve(props);

      var doAdd = function (pdfUrl, cartProps) {

        var p = cartProps || props;

        if (pdfUrl) {

          var pdfKey = (typeof window.lcHiddenPropKey === 'function')

            ? window.lcHiddenPropKey('pdf', 'PDF')

            : '_PDF';

          p[pdfKey] = pdfUrl;

        }

        return fetch('/cart/add.js', {

          method: 'POST',

          headers: { 'Content-Type': 'application/json' },

          body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: p }] })

        }).then(function (r) { return r.json(); });

      };

      var promise = attachPreview.then(function (cartProps) {

        var previewKey = window.LC_CART_PREVIEW_KEY || '_LC Preview';

        var previewImage = cartProps[previewKey] || '';

        if (window.lcPdfBackendUrl && previewImage) {

          var pdfGen = (typeof window.lcGenerateVectorPdfForUpload === 'function')

            ? window.lcGenerateVectorPdfForUpload()

            : Promise.resolve('');

          return pdfGen.then(function (pdfBase64) {

            if (!pdfBase64) {

              try { console.warn('[LC] PDF vectoriel non genere — repli worker (qualite reduite)'); } catch (eW) {}

            }

            var payload = { image: previewImage };

            if (pdfBase64) payload.pdf_base64 = pdfBase64;

            return fetch(window.lcPdfBackendUrl, {

              method: 'POST',

              headers: { 'Content-Type': 'application/json' },

              body: JSON.stringify(payload)

            });

          }).then(function (r) {

            return r.json().then(function (data) {

              var thumbUrl = data && (data.thumbnail_url || data.url);

              var pdfUrl = data && data.pdf_url;

              if (!r.ok || (data && data.error) || (!thumbUrl && !pdfUrl)) {

                try {

                  console.warn('[LC] PDF backend:', (data && data.error) || r.status);

                } catch (e) {}

                return lcFinalizeCartPreviewProps(cartProps).then(function (p) {

                  return doAdd(null, p);

                });

              }

              var thumbKey = (typeof window.lcHiddenPropKey === 'function')

                ? window.lcHiddenPropKey('custom thumbnail', 'Custom Thumbnail')

                : '_Custom Thumbnail';

              if (thumbUrl) {

                cartProps[previewKey] = thumbUrl;

                cartProps[thumbKey] = thumbUrl;

              }

              return doAdd(pdfUrl || null, cartProps);

            });

          }).catch(function (err) {

            try { console.warn('[LC] PDF backend fetch failed', err); } catch (e2) {}

            return lcFinalizeCartPreviewProps(cartProps).then(function (p) {

              return doAdd(null, p);

            });

          });

        }

        return lcFinalizeCartPreviewProps(cartProps).then(function (p) {

          return doAdd(null, p);

        });

      });

      if (addBtn) addBtn.disabled = true;

      promise.then(function (data) {

        if (data.message && data.status && data.status !== 200) {

          if (addBtn) addBtn.disabled = false;

          return;

        }

        try { document.dispatchEvent(new CustomEvent('lc:cart-added')); } catch (err) {}

        if (window.lcRedirectToCart) window.location.href = '/cart';

        if (typeof theme !== 'undefined' && theme.openCartDrawer) theme.openCartDrawer();

      }).catch(function () { if (addBtn) addBtn.disabled = false; });

    }



    if (!lcCartConfirmEnabled()) {

      performAdd();

      return;

    }



    var exportPreview = window.lcExportPreviewDataUrlForUi || window.lcExportPreviewDataUrl;

    var previewPromise = (typeof exportPreview === 'function' && canvas)

      ? exportPreview(canvas)

      : Promise.resolve('');



    lcOpenCartConfirmModal(previewPromise, props).then(function (confirmed) {

      if (confirmed) performAdd();

    });

  }



  window.lcRunShopifyCartAdd = runShopifyCartAdd;



  if (window.lcProductFormId && window.lcProductJsonId) {

    var form = document.getElementById(window.lcProductFormId);

    var productJsonEl = document.getElementById(window.lcProductJsonId);

    var variantInput = document.getElementById(window.lcVariantIdInputId);

    var priceEl = document.getElementById(window.lcPriceElementId);

    var addBtn = document.getElementById(window.lcAddToCartButtonId);

    if (form && productJsonEl && variantInput) {

      var product = JSON.parse(productJsonEl.textContent);

      var variants = product.variants || [];



      function getSelectedOptions() {

        var opts = [];

        form.querySelectorAll('.lc-option-select').forEach(function (sel) { opts.push(sel.value); });

        return opts;

      }

      function findVariant() {

        var selects = form.querySelectorAll('.lc-option-select');

        if (selects.length === 0) return variants[0] || null;

        var selected = getSelectedOptions();

        return variants.find(function (v) {

          return v.options && v.options.length === selected.length && v.options.every(function (opt, i) { return opt === selected[i]; });

        }) || variants[0];

      }

      function updateVariant(variant) {

        if (!variant) return;

        variantInput.value = variant.id;

        if (priceEl) priceEl.textContent = (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? Shopify.formatMoney(variant.price) : ((variant.price / 100).toFixed(2) + ' ' + (product.currency || ''));

        if (addBtn) {

          addBtn.disabled = !variant.available;

          addBtn.textContent = variant.available ? (window.lcAddToCartText || 'Ajouter au panier') : (window.lcSoldOutText || 'Rupture de stock');

        }

      }

      form.querySelectorAll('.lc-option-select').forEach(function (sel) {

        sel.addEventListener('change', function () { updateVariant(findVariant()); });

      });

      updateVariant(product.selected_or_first_available_variant || findVariant());



      form.addEventListener('submit', function (e) {

        e.preventDefault();

        if (typeof window.lcCartHasRequiredText === 'function' && !window.lcCartHasRequiredText()) {

          if (typeof window.lcNotifyCartTextRequired === 'function') window.lcNotifyCartTextRequired();

          return;

        }

        var variant = findVariant();

        if (!variant || !variant.available) return;

        var qty = parseInt(getQuantityInput() ? getQuantityInput().value : 1, 10) || 1;

        var canvas = document.getElementById('previewCanvas');

        var props = (typeof window.lcBuildLineItemProperties === 'function')

          ? window.lcBuildLineItemProperties()

          : {};

        runShopifyCartAdd({

          variant: variant,

          quantity: qty,

          props: props,

          canvas: canvas,

          addBtn: addBtn

        });

      });

    }

  }



});



/** Couleurs legacy par fichier modele — fallback si absent du preset */
window.LC_MODEL_COLORS = {
	//DIVERS
    'kit-sushi-JUIN07-2024.jpg': ['#FFC0CB', '#FFD700'], // Pink and Gold
    'kit_agrumes_2024.jpg': ['#FFA500', '#FFFF00'], // Orange and Yellow
    'kit_ananas_blue_2024.jpg': ['#0000FF', '#00FFFF'], // Blue and Cyan
    'kit_ananas_mauve_2024.jpg': ['#800080', '#FFC0CB'], // Purple and Pink
    'kit_arc-en-ciel_2024.jpg': ['#FF0000', '#FFA500', '#FFFF00', '#008000', '#0000FF'], // Rainbow
    'kit_Astronaut_2024.jpg': ['#000000', '#FFFFFF'], // Black and White
    'kit_beignet_2024.jpg': ['#D2691E', '#FFDAB9'], // Brown and Peach
    'kit_biscuit_2024.jpg': ['#F4A460', '#DEB887'], // Sandy and Tan
    'kit_Boho_2024.jpg': ['#A52A2A', '#D2B48C'], // Brown and Tan
    'kit_bucheron_2024.jpg': ['#8B0000', '#000000'], // Dark Red and Black
    'kit_cactus bleu_2024.jpg': ['#008080', '#0000FF'], // Teal and Blue
    'kit_cactus jaune_2024.jpg': ['#FFD700', '#FFA500'], // Yellow and Orange
    'kit_campeur_2024.jpg': ['#556B2F', '#8B4513'], // Olive and SaddleBrown
    'kit_camping_2024.jpg': ['#32CD32', '#8B4513'], // LimeGreen and SaddleBrown
    'kit_carnaval_2024.jpg': ['#FF4500', '#1E90FF'], // OrangeRed and DodgerBlue
    'kit_champignon1_2024.jpg': ['#A0522D', '#FF6347'], // Sienna and Tomato
    'kit_champignon2_2024.jpg': ['#A0522D', '#8B4513'], // Sienna and SaddleBrown
    'kit_coeur_2024.jpg': ['#FF0000', '#FFC0CB'], // Red and Pink
    'kit_douceur_2024.jpg': ['#FFB6C1', '#FFFFE0'], // LightPink and LightYellow
    'kit_Douce_melodie_2024.jpg': ['#7B68EE', '#87CEFA'], // MediumSlateBlue and LightSkyBlue
    'kit_ferme_2024.jpg': ['#8B4513', '#32CD32'], // SaddleBrown and LimeGreen
    'kit_feuillus 2_2024.jpg': ['#228B22', '#556B2F'], // ForestGreen and DarkOliveGreen
    'kit_finesse_2024.jpg': ['#DDA0DD', '#FFDAB9'], // Plum and PeachPuff
    'kit_fleur_2024.jpg': ['#FF69B4', '#87CEEB'], // HotPink and SkyBlue
    'kit_fraises_2024.jpg': ['#FF0000', '#32CD32'], // Red and LimeGreen
    'kit_gamer rouge_2024.jpg': ['#FF0000', '#000000'], // Red and Black
    'kit_gamer vert_2024.jpg': ['#008000', '#000000'], // Green and Black
    'kit_glacee_2024.jpg': ['#00FFFF', '#E0FFFF'], // Cyan and LightCyan
    'kit_insecte_2024.jpg': ['#556B2F', '#8B0000'], // DarkOliveGreen and DarkRed
    'kit_machienrie_2024.jpg': ['#B0C4DE', '#708090'], // LightSteelBlue and SlateGray
    'kit_magie_2024.jpg': ['#4B0082', '#8A2BE2'], // Indigo and BlueViolet
    'kit_Melon_2024.jpg': ['#FF6347', '#FFD700'], // Tomato and Gold
    'kit_mer_2024.jpg': ['#4682B4', '#00BFFF'], // SteelBlue and DeepSkyBlue
    'kit_motocross_2024.jpg': ['#FF4500', '#FFD700'], // OrangeRed and Gold
    'kit_moustache_2024.jpg': ['#000000', '#A9A9A9'], // Black and DarkGray
    'kit_NEW_cupcake_2024.jpg': ['#FF69B4', '#87CEEB'], // HotPink and SkyBlue
    'kit_petite_foret_2024.jpg': ['#228B22', '#6B8E23'], // ForestGreen and OliveDrab
    'kit_princesse_2024.jpg': ['#FF69B4', '#DDA0DD'], // HotPink and Plum
    'kit_ptitmonstre_2024.jpg': ['#8B0000', '#00008B'], // DarkRed and DarkBlue
    'kit_Souslocean_2024.jpg': ['#1E90FF', '#00BFFF'], // DodgerBlue and DeepSkyBlue
    'kit_superhero_2024.jpg': ['#0000FF', '#FFD700'], // Blue and Gold
    'kit_Tracteur_2024.jpg': ['#228B22', '#FF4500'], // ForestGreen and OrangeRed
    'kit_tropique_2024.jpg': ['#FFD700', '#FF6347'], // Gold and Tomato
	//ANIMAUX
	    'kit_cameleon_2024-new.jpg': ['#008000', '#FFD700'], // Green and Gold
    'kit_chat_2024.jpg': ['#D3D3D3', '#000000'], // LightGray and Black
    'kit_cheval_2024.jpg': ['#A52A2A', '#8B4513'], // Brown and SaddleBrown
    'kit_chien_2024.jpg': ['#8B4513', '#D2691E'], // SaddleBrown and Chocolate
    'kit_cochon_2024.jpg': ['#FFC0CB', '#FF69B4'], // Pink and HotPink
    'kit_Dino Rose_2024.jpg': ['#FF69B4', '#FFD700'], // HotPink and Gold
    'kit_dino vert_2024.jpg': ['#008000', '#006400'], // Green and DarkGreen
    'kit_foret_2024.jpg': ['#228B22', '#6B8E23'], // ForestGreen and OliveDrab
    'kit_herisson_2024.jpg': ['#A0522D', '#DEB887'], // Sienna and BurlyWood
    'kit_Koala_2024.jpg': ['#696969', '#A9A9A9'], // DimGray and DarkGray
    'kit_Lapin-doux_2024.jpg': ['#FFDAB9', '#F5DEB3'], // PeachPuff and Wheat
    'kit_lapin_2024.jpg': ['#FFE4B5', '#8B4513'], // Moccasin and SaddleBrown
    'kit_licorne_2024.jpg': ['#FF69B4', '#87CEEB'], // HotPink and SkyBlue
    'kit_minou_2024.jpg': ['#FFD700', '#000000'], // Gold and Black
    'kit_NEW_flamant_2024.jpg': ['#FF69B4', '#FF4500'], // HotPink and OrangeRed
    'kit_panda_2024.jpg': ['#000000', '#FFFFFF'], // Black and White
    'kit_paresseux_2024.jpg': ['#8B4513', '#A0522D'], // SaddleBrown and Sienna
    'kit_pitou_2024.jpg': ['#D2691E', '#FFD700'], // Chocolate and Gold
    'kit_Pug_2024.jpg': ['#A52A2A', '#FFDAB9'], // Brown and PeachPuff
    'kit_renard bleu_2024.jpg': ['#0000FF', '#1E90FF'], // Blue and DodgerBlue
    'kit_renard rose_2024.jpg': ['#FFC0CB', '#FF69B4'], // Pink and HotPink
    'kit_renard_2024.jpg': ['#FFA500', '#FF4500'], // Orange and OrangeRed
    'kit_savane_2024.jpg': ['#FFD700', '#F4A460'], // Gold and SandyBrown
    'kit_singe_2024.jpg': ['#8B4513', '#D2691E'], // SaddleBrown and Chocolate
    'kit_sirene_2024.jpg': ['#87CEEB', '#00BFFF'], // SkyBlue and DeepSkyBlue
    'kit_tortue_2024.jpg': ['#008000', '#32CD32'], // Green and LimeGreen
	//SPORT
	    'kit_Ballerine A_2024.jpg': ['#FF69B4', '#FFDAB9'], // HotPink and Peach
    'kit_Ballerine B_2024.jpg': ['#FF1493', '#FFE4B5'], // DeepPink and Moccasin
    'kit_Baseball_2024.jpg': ['#0000FF', '#FFFFFF'], // Blue and White
    'kit_Hockey_2024.jpg': ['#000000', '#FF0000'], // Black and Red
    'kit_Skateboard_2024.jpg': ['#32CD32', '#FFD700'], // LimeGreen and Gold
    'kit_Soccer_2024.jpg': ['#008000', '#FFFFFF'], // Green and White
    'kit_Surf_2024.jpg': ['#00CED1', '#1E90FF'], // DarkTurquoise and DodgerBlue
    'kit_voiture rose_2024.jpg': ['#FFC0CB', '#000000'], // Pink and Black
	//UNI
	'kit-blanc.jpg': ['#000000', '#D3D3D3'], // Black and LightGray
    'kit-camoufle.jpg': ['#556B2F', '#8B4513'], // DarkOliveGreen and SaddleBrown
    'kit-cieldete.jpg': ['#87CEEB', '#1E90FF'], // SkyBlue and DodgerBlue
    'kit-lagrappe.jpg': ['#800080', '#FFC0CB'], // Purple and Pink
    'kit-lavague-new.jpg': ['#4682B4', '#00BFFF'], // SteelBlue and DeepSkyBlue
    'kit-leclatant.jpg': ['#FFD700', '#FFA500'], // Gold and Orange
    'kit-Lefeuillus.jpg': ['#228B22', '#6B8E23'], // ForestGreen and OliveDrab
    'kit-letoile.jpg': ['#00008B', '#FFFFFF'], // DarkBlue and White
    'kit-locre.jpg': ['#DAA520', '#8B4513'], // GoldenRod and SaddleBrown
    'kit-lorangier.jpg': ['#FF4500', '#FF6347'], // OrangeRed and Tomato
    'kit-rosee.jpg': ['#FFC0CB', '#FFF5EE'], // Pink and Seashell
	//CHSLD
	'kit_marguerite_2024.jpg': ['#000000', '#D3D3D3'], // Black and LightGray
	'kit_pivoine_2024.jpg': ['#000000', '#D3D3D3'], // Black and LightGray
	'kit_poisoon_2024.jpg': ['#000000', '#D3D3D3'], // Black and LightGray
	'kit_Rosie_2024.jpg': ['#000000', '#D3D3D3'], // Black and LightGray
	'kit_voiture verte_2024.jpg': ['#000000', '#D3D3D3'] // Black and LightGray
};

/**
 * LC Label Customizer — utilitaires presets partagés (customizer + éditeur)
 */
(function (global) {
  'use strict';

  var DEFAULT_COLORS = ['#000000', '#FF1493', '#1E90FF', '#FFD700'];

  function normalizeHexColor(c) {
    if (c == null || c === '') return '';
    var s = String(c).trim();
    var m = s.match(/^#([0-9a-fA-F]{6})$/);
    return m ? ('#' + m[1].toUpperCase()) : s;
  }

  /** Entrée couleur : string hex legacy ou { hex, name }. */
  function parseColorEntry(entry) {
    if (entry == null || entry === '') return { hex: '#000000', name: '' };
    if (typeof entry === 'string') {
      return { hex: normalizeHexColor(entry) || '#000000', name: '' };
    }
    if (typeof entry === 'object') {
      return {
        hex: normalizeHexColor(entry.hex || entry.color || entry.value || '') || '#000000',
        name: String(entry.name || entry.label || '').trim()
      };
    }
    return { hex: '#000000', name: '' };
  }

  function normalizeColorList(list) {
    if (!list || !list.length) return [];
    return list.map(parseColorEntry);
  }

  function colorListToHexArray(list) {
    return normalizeColorList(list).map(function (e) { return e.hex; });
  }

  function serializeColorListForExport(list) {
    return normalizeColorList(list).map(function (e) {
      if (e.name) return { hex: e.hex, name: e.name };
      return e.hex;
    });
  }

  function getColorEntriesForModel(preset, modelFileName) {
    if (!modelFileName || !preset || !preset.categories) return [];
    for (var i = 0; i < preset.categories.length; i++) {
      var models = preset.categories[i].models || [];
      for (var j = 0; j < models.length; j++) {
        var m = models[j];
        var file = typeof m === 'string' ? m : (m.file || m.value);
        if (file === modelFileName && m.colors && m.colors.length) {
          return normalizeColorList(m.colors);
        }
      }
    }
    return [];
  }

  function getColorLabelForModel(preset, modelFileName, hexColor) {
    var key = normalizeHexColor(hexColor);
    if (!key) return '';
    var entries = getColorEntriesForModel(preset, modelFileName);
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].hex === key && entries[i].name) return entries[i].name;
    }
    return '';
  }

  function humanizeModelFileName(file) {
    if (!file) return '';
    var base = String(file).replace(/\.jpe?g$/i, '');
    return base.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /** Nom affiché panier / commande — preset (name) puis nom de fichier lisible. */
  function getModelLabelForModel(preset, modelFileName) {
    if (!modelFileName) return '';
    if (preset && preset.categories) {
      for (var i = 0; i < preset.categories.length; i++) {
        var models = preset.categories[i].models || [];
        for (var j = 0; j < models.length; j++) {
          var m = models[j];
          var file = typeof m === 'string' ? m : (m.file || m.value);
          if (file === modelFileName && m && typeof m === 'object') {
            var name = String(m.name || m.label || '').trim();
            if (name) return name;
            break;
          }
        }
      }
    }
    return humanizeModelFileName(modelFileName);
  }

  function resolveLegacyColorKey(modelFileName, fb) {
    if (!modelFileName || !fb) return null;
    if (fb[modelFileName]) return modelFileName;

    var candidates = [
      modelFileName,
      modelFileName.replace(/^petite[_-]/i, 'kit_'),
      modelFileName.replace(/^petite[_-]/i, 'kit-'),
      modelFileName.replace(/^moyenne[_-]/i, 'kit_'),
      modelFileName.replace(/^moyen[_-]/i, 'kit_'),
      modelFileName.replace(/^petite[_-]/i, ''),
      modelFileName.replace(/^moyenne[_-]/i, ''),
      modelFileName.replace(/^moyen[_-]/i, '')
    ];

    var seen = {};
    for (var i = 0; i < candidates.length; i++) {
      var c = candidates[i];
      if (!c || seen[c]) continue;
      seen[c] = true;
      if (fb[c]) return c;
    }

    var core = modelFileName
      .replace(/^petite[_-]/i, '')
      .replace(/^moyenne[_-]/i, '')
      .replace(/^moyen[_-]/i, '');

    if (core && core !== modelFileName) {
      var keys = Object.keys(fb);
      for (var j = 0; j < keys.length; j++) {
        var key = keys[j];
        var kitCore = key.replace(/^kit[_-]/i, '');
        if (kitCore === core) return key;
        if (key.indexOf(core) >= 0 || core.indexOf(kitCore) >= 0) return key;
      }
    }

    return null;
  }

  function lookupLegacyColors(modelFileName, fb) {
    var key = resolveLegacyColorKey(modelFileName, fb);
    return key && fb[key] && fb[key].length ? fb[key].slice() : null;
  }

  function modelFile(m) {
    if (!m) return '';
    if (typeof m === 'string') return m.trim();
    return (m.file || m.value || '').trim();
  }

  function normalizeModel(m, fallbackColors) {
    if (typeof m === 'string') {
      var file = m.trim();
      var legacyHex = lookupLegacyColors(file, fallbackColors);
      return { file: file, name: '', colors: legacyHex ? normalizeColorList(legacyHex) : null };
    }
    if (m && typeof m === 'object') {
      var f = modelFile(m);
      var c = m.colors && m.colors.length ? normalizeColorList(m.colors) : null;
      if (!c || !c.length) {
        var legacy = lookupLegacyColors(f, fallbackColors);
        c = legacy ? normalizeColorList(legacy) : null;
      }
      return {
        file: f,
        name: String(m.name || m.label || '').trim(),
        colors: c
      };
    }
    return { file: '', name: '', colors: null };
  }

  function normalizeCategory(cat, fallbackColors) {
    var models = (cat.models || []).map(function (m) {
      return normalizeModel(m, fallbackColors);
    }).filter(function (m) { return m.file; });
    return {
      id: cat.id || '',
      name: cat.name || '',
      baseUrl: cat.baseUrl != null ? cat.baseUrl : '',
      models: models
    };
  }

  function normalizePreset(preset, fallbackColors) {
    if (!preset) return null;
    var fb = fallbackColors || global.LC_MODEL_COLORS || {};
    var out = {
      id: preset.id || '',
      name: preset.name || preset.id || '',
      mask: preset.mask || 'mask.png',
      boxes: (preset.boxes || []).map(function (b) {
        var c = {};
        for (var k in b) if (b.hasOwnProperty(k)) c[k] = b[k];
        return c;
      })
    };
    if (preset.categories && preset.categories.length) {
      out.categories = preset.categories.map(function (cat) {
        return normalizeCategory(cat, fb);
      });
    }
    if (preset.modelColors && typeof preset.modelColors === 'object') {
      out.modelColors = preset.modelColors;
    }
    if (preset.defaultTextAlign) out.defaultTextAlign = preset.defaultTextAlign;
    if (preset.textFitMode === 'perLine' || preset.textFitMode === 'uniform') {
      out.textFitMode = preset.textFitMode;
    }
    return out;
  }

  function getColorsForModel(preset, modelFileName) {
    if (!modelFileName) return DEFAULT_COLORS.slice();
    var fb = global.LC_MODEL_COLORS || {};

    if (preset && preset.categories) {
      for (var i = 0; i < preset.categories.length; i++) {
        var cat = preset.categories[i];
        var models = cat.models || [];
        for (var j = 0; j < models.length; j++) {
          var m = models[j];
          var file = typeof m === 'string' ? m : (m.file || m.value);
          if (file === modelFileName) {
            if (typeof m === 'object' && m.colors && m.colors.length) {
              return colorListToHexArray(m.colors);
            }
            break;
          }
        }
      }
    }

    if (preset && preset.modelColors && preset.modelColors[modelFileName]) {
      var mc = preset.modelColors[modelFileName];
      if (mc && mc.length) return mc.slice();
    }

    var legacy = lookupLegacyColors(modelFileName, fb);
    if (legacy) return legacy;

    return DEFAULT_COLORS.slice();
  }

  function resolveBoxTextAlign(box, presetDefault, globalAlign, multiBox, isUniCategory) {
    if (isUniCategory && box && box.type !== 'circle') return 'center';
    if (box && box.type === 'circle') {
      if (!multiBox && globalAlign) return globalAlign;
      if (box.textAlign) return box.textAlign;
      return 'center';
    }
    if (globalAlign) return globalAlign;
    if (box && box.textAlign) return box.textAlign;
    if (presetDefault) return presetDefault;
    return 'left';
  }

  function buildPresetExport(preset) {
    var out = {
      id: preset.id,
      name: preset.name,
      mask: preset.mask,
      boxes: preset.boxes
    };
    if (preset.defaultTextAlign) out.defaultTextAlign = preset.defaultTextAlign;
    if (preset.textFitMode === 'perLine' || preset.textFitMode === 'uniform') {
      out.textFitMode = preset.textFitMode;
    }
    if (preset.categories && preset.categories.length) {
      out.categories = preset.categories.map(function (cat) {
        var c = {
          id: cat.id || undefined,
          name: cat.name || undefined,
          baseUrl: cat.baseUrl || undefined,
          models: (cat.models || []).map(function (m) {
            if (typeof m === 'string') return m;
            var o = { file: m.file };
            if (m.name) o.name = m.name;
            if (m.colors && m.colors.length) o.colors = serializeColorListForExport(m.colors);
            return o;
          }).filter(function (m) {
            return typeof m === 'string' ? m : m.file;
          })
        };
        return c;
      }).filter(function (c) { return c.id || c.name || (c.models && c.models.length); });
    }
    return out;
  }

  function mergePresetsIntoJs(presetsObj) {
    var lines = ['window.LC_PRESETS = window.LC_PRESETS || {};'];
    Object.keys(presetsObj).forEach(function (id) {
      lines.push("window.LC_PRESETS['" + id.replace(/'/g, "\\'") + "'] = " + JSON.stringify(presetsObj[id], null, 2) + ';');
    });
    return lines.join('\n');
  }

  /** Retire émojis / pictogrammes (saisie étiquettes). Accents et ponctuation conservés. */
  function sanitizeLabelText(str) {
    if (str == null || str === '') return '';
    var s = String(str);
    try {
      return s
        .replace(/\p{Extended_Pictographic}/gu, '')
        .replace(/[\u{1F3FB}-\u{1F3FF}]/gu, '')
        .replace(/\uFE0F/g, '')
        .replace(/\u200D/g, '');
    } catch (e) {
      return s.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '');
    }
  }

  global.LCPresetUtils = {
    modelFile: modelFile,
    normalizeModel: normalizeModel,
    normalizeCategory: normalizeCategory,
    normalizePreset: normalizePreset,
    getColorsForModel: getColorsForModel,
    normalizeHexColor: normalizeHexColor,
    parseColorEntry: parseColorEntry,
    normalizeColorList: normalizeColorList,
    colorListToHexArray: colorListToHexArray,
    getColorLabelForModel: getColorLabelForModel,
    getModelLabelForModel: getModelLabelForModel,
    humanizeModelFileName: humanizeModelFileName,
    resolveLegacyColorKey: resolveLegacyColorKey,
    lookupLegacyColors: lookupLegacyColors,
    resolveBoxTextAlign: resolveBoxTextAlign,
    buildPresetExport: buildPresetExport,
    mergePresetsIntoJs: mergePresetsIntoJs,
    sanitizeLabelText: sanitizeLabelText,
    DEFAULT_COLORS: DEFAULT_COLORS
  };
})(typeof window !== 'undefined' ? window : globalThis);

// Wait for the DOM to fully load before executing the script
function lcStr(key, fallback) {
  var o = window.lcStrings;
  if (!o) return fallback;
  var parts = key.split('.');
  for (var i = 0; i < parts.length; i++) {
    if (o == null || typeof o !== 'object') return fallback;
    o = o[parts[i]];
  }
  return typeof o === 'string' && o.length ? o : fallback;
}

function lcCategoryLabel(id, fallback) {
  return lcStr('categories.' + id, fallback || id);
}

function lcPropKey(name, fallback) {
  return lcStr('props.' + name, fallback);
}

function lcNormalizeHexColor(color) {
  if (!color) return '';
  var s = String(color).trim();
  var hex = s.match(/^#([0-9a-fA-F]{6})$/);
  if (hex) return '#' + hex[1].toUpperCase();
  var rgb = s.match(/^rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i);
  if (rgb) {
    function pad2(n) {
      var h = Math.max(0, Math.min(255, parseInt(n, 10))).toString(16);
      return h.length === 1 ? '0' + h : h;
    }
    return ('#' + pad2(rgb[1]) + pad2(rgb[2]) + pad2(rgb[3])).toUpperCase();
  }
  return s;
}

/** Nom affiché (panier, accessibilité) — preset modèle puis locales/lc-customizer.translations.json */
function lcColorDisplayName(color, modelFileName) {
  if (!color) return '';
  var hex = lcNormalizeHexColor(color);
  var preset = window.lcPreset || null;
  var model = modelFileName || window.lcSelectedModel || '';
  if (hex && model && preset && window.LCPresetUtils && window.LCPresetUtils.getColorLabelForModel) {
    var fromPreset = window.LCPresetUtils.getColorLabelForModel(preset, model, hex);
    if (fromPreset) return fromPreset;
  }
  var map = (window.lcStrings && window.lcStrings.colorNames) || {};
  if (hex && map[hex]) return map[hex];
  return color;
}

/** Nom affiché du modèle (panier, confirmation) — preset puis nom de fichier lisible. */
function lcModelDisplayName(modelFileName) {
  if (!modelFileName) return '';
  var preset = window.lcPreset || null;
  var model = modelFileName || window.lcSelectedModel || '';
  if (preset && window.LCPresetUtils && window.LCPresetUtils.getModelLabelForModel) {
    return window.LCPresetUtils.getModelLabelForModel(preset, model);
  }
  return model;
}

/** Propriétés panier masquées côté client (préfixe _ — règle Shopify). */
function lcHiddenPropKey(name, fallback) {
  var key = lcPropKey(name, fallback);
  return key.charAt(0) === '_' ? key : '_' + key;
}

/** Clé fixe pour la vignette panier (snippet Liquid lc-cart-item-media). */
var LC_CART_PREVIEW_KEY = '_LC Preview';
/** Limite Shopify ~5000 car. par valeur de propriété line item. */
var LC_CART_PREVIEW_MAX_CHARS = 4800;

function lcUrlOrigin(url) {
  try {
    return new URL(url, window.location.href).origin;
  } catch (e) {
    return window.location.origin;
  }
}

/** Évite le cache navigateur d’anciennes réponses R2 sans en-têtes CORS. */
function lcMediaUrlNoCache(url) {
  if (!url || String(url).indexOf('data:') === 0) return url;
  try {
    var u = new URL(url, window.location.href);
    u.searchParams.set('lcnc', '1');
    return u.toString();
  } catch (e) {
    return url;
  }
}

/** crossOrigin=anonymous seulement si l’URL est sur un autre domaine (évite canvas tainted sur CDN Shopify). */
function lcApplyImageCrossOrigin(img, url) {
  if (!img || !url) return;
  if (lcUrlOrigin(url) !== window.location.origin) {
    img.crossOrigin = 'anonymous';
  } else {
    img.removeAttribute('crossorigin');
    try { img.crossOrigin = null; } catch (e2) { /* IE */ }
  }
}

function lcSafeCanvasDataUrl(canvas) {
  if (!canvas || typeof canvas.toDataURL !== 'function') return '';
  try {
    return canvas.toDataURL('image/png');
  } catch (e) {
    return '';
  }
}

/** JPEG réduit pour tenir dans la propriété panier (data URL). */
function lcCompressPreviewDataUrlForCart(dataUrl, maxChars) {
  maxChars = maxChars || LC_CART_PREVIEW_MAX_CHARS;
  if (!dataUrl || typeof dataUrl !== 'string') return Promise.resolve('');
  if (dataUrl.indexOf('http://') === 0 || dataUrl.indexOf('https://') === 0) {
    return Promise.resolve(dataUrl);
  }
  if (dataUrl.length <= maxChars) return Promise.resolve(dataUrl);

  return new Promise(function (resolve) {
    var img = new Image();
    img.onload = function () {
      var iw = img.naturalWidth || img.width;
      var ih = img.naturalHeight || img.height;
      if (!iw || !ih) {
        resolve('');
        return;
      }
      var maxW = 160;
      var out = '';
      while (maxW >= 48 && !out) {
        var scale = Math.min(1, maxW / iw);
        var cw = Math.max(1, Math.round(iw * scale));
        var ch = Math.max(1, Math.round(ih * scale));
        var c = document.createElement('canvas');
        c.width = cw;
        c.height = ch;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        var q = 0.88;
        while (q >= 0.25) {
          try {
            out = c.toDataURL('image/jpeg', q);
          } catch (e2) {
            out = '';
            break;
          }
          if (out.length <= maxChars) break;
          q -= 0.06;
          out = '';
        }
        if (out && out.length <= maxChars) break;
        out = '';
        maxW = Math.round(maxW * 0.72);
      }
      resolve(out && out.length <= maxChars ? out : '');
    };
    img.onerror = function () { resolve(''); };
    img.src = dataUrl;
  });
}

function lcLoadImageViaBlob(url) {
  if (!url) return Promise.reject(new Error('no url'));
  return fetch(lcMediaUrlNoCache(url), { mode: 'cors', credentials: 'omit', cache: 'no-store' }).then(function (r) {
    if (!r.ok) throw new Error('fetch image');
    return r.blob();
  }).then(function (blob) {
    var objUrl = URL.createObjectURL(blob);
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve({ img: img, revoke: objUrl }); };
      img.onerror = function () {
        URL.revokeObjectURL(objUrl);
        reject(new Error('blob image'));
      };
      img.src = objUrl;
    });
  }).catch(function () {
    return lcLoadModelImage(url).then(function (pack) {
      if (!pack.corsOk) return Promise.reject(new Error('model not exportable'));
      return { img: pack.img, revoke: null };
    });
  });
}

/** JPG modèle : essai CORS (canvas exportable), repli sans crossOrigin (preview visible). */
function lcLoadModelImage(modelUrl) {
  return new Promise(function (resolve, reject) {
    var settled = false;
    function finish(image, corsOk) {
      if (settled) return;
      settled = true;
      resolve({ img: image, corsOk: corsOk });
    }
    function fail() {
      if (settled) return;
      settled = true;
      reject(new Error('model image load failed'));
    }
    var img = new Image();
    lcApplyImageCrossOrigin(img, modelUrl);
    img.onload = function () { finish(img, true); };
    img.onerror = function () {
      var plain = new Image();
      plain.onload = function () { finish(plain, false); };
      plain.onerror = fail;
      plain.src = modelUrl;
    };
    img.src = lcMediaUrlNoCache(modelUrl);
  });
}

function lcDrawImageContain(ctx, img, x, y, w, h) {
  var iw = img.naturalWidth || img.width;
  var ih = img.naturalHeight || img.height;
  if (!iw || !ih) return;
  var scale = Math.min(w / iw, h / ih);
  var dw = iw * scale;
  var dh = ih * scale;
  var dx = x + (w - dw) / 2;
  var dy = y + (h - dh) / 2;
  ctx.drawImage(img, dx, dy, dw, dh);
}

function lcCompositeCanvasWithMaskImage(canvas, maskImg) {
  if (!canvas) return '';
  var w = canvas.width;
  var h = canvas.height;
  var out = document.createElement('canvas');
  out.width = w;
  out.height = h;
  var ctx = out.getContext('2d');
  ctx.drawImage(canvas, 0, 0);
  if (maskImg && (maskImg.naturalWidth || maskImg.width)) {
    lcDrawImageContain(ctx, maskImg, 0, 0, w, h);
  }
  return lcSafeCanvasDataUrl(out);
}

function lcCanvasWithMaskDataUrl(canvas) {
  var maskEl = document.getElementById('maskLayer');
  if (!maskEl || !(maskEl.naturalWidth > 0)) {
    return lcSafeCanvasDataUrl(canvas);
  }
  return lcCompositeCanvasWithMaskImage(canvas, maskEl);
}

function lcExportPreviewWithMaskBlob(canvas, maskSrc) {
  if (!canvas) return Promise.resolve('');
  var direct = lcSafeCanvasDataUrl(canvas);
  if (!direct) return Promise.resolve('');
  if (!maskSrc) return Promise.resolve(direct);
  return lcLoadImageViaBlob(maskSrc).then(function (pack) {
    var url = '';
    try {
      url = lcCompositeCanvasWithMaskImage(canvas, pack.img);
    } finally {
      URL.revokeObjectURL(pack.revoke);
    }
    return url || direct;
  }).catch(function () {
    return lcCanvasWithMaskDataUrl(canvas) || direct;
  });
}

/** Export PNG preview (canvas + masque), sans lever d’exception. */
function lcExportPreviewDataUrl(canvas) {
  if (!canvas) return Promise.resolve('');
  var maskEl = document.getElementById('maskLayer');
  var maskSrc = maskEl && (maskEl.currentSrc || maskEl.src);
  var direct = lcSafeCanvasDataUrl(canvas);

  if (direct) {
    return lcExportPreviewWithMaskBlob(canvas, maskSrc);
  }

  if (typeof window.lcRebuildExportPreviewDataUrl === 'function') {
    return window.lcRebuildExportPreviewDataUrl();
  }

  return Promise.resolve('');
}

/** Attend le dernier updatePreview, puis export (modale + panier). */
function lcExportPreviewDataUrlForUi(canvas) {
  canvas = canvas || document.getElementById('previewCanvas');
  var waitFn = window.lcWhenPreviewReadyForExport;
  var wait = (typeof waitFn === 'function')
    ? waitFn({ timeoutMs: 15000, refresh: false })
    : Promise.resolve(true);
  function rebuild() {
    if (typeof window.lcRebuildExportPreviewDataUrl === 'function') {
      return window.lcRebuildExportPreviewDataUrl();
    }
    return Promise.resolve('');
  }
  return wait.then(function () {
    return rebuild().then(function (url) {
      if (url) return url;
      return lcExportPreviewDataUrl(canvas).then(function (url2) {
        if (url2) return url2;
        return rebuild();
      });
    });
  });
}

/** Ajoute _LC Preview (canvas + masque). Retourne une Promise. */
function lcAttachCartPreview(props, canvas) {
  if (!props) return Promise.resolve(props || {});
  if (!canvas) return Promise.resolve(props);
  return lcExportPreviewDataUrlForUi(canvas).then(function (url) {
    if (!url) return props;
    var maxChars = LC_CART_PREVIEW_MAX_CHARS;
    if (url.length <= maxChars) {
      props[LC_CART_PREVIEW_KEY] = url;
      return props;
    }
    return lcCompressPreviewDataUrlForCart(url, maxChars).then(function (compressed) {
      if (compressed) {
        props[LC_CART_PREVIEW_KEY] = compressed;
        return props;
      }
      return lcCompressPreviewDataUrlForCart(url, 3200).then(function (smaller) {
        if (smaller) props[LC_CART_PREVIEW_KEY] = smaller;
        return props;
      });
    });
  });
}

function pickLcPresetFromWindow() {
  var presets = window.LC_PRESETS || {};
  var id = typeof window.lcPresetId === 'string' ? window.lcPresetId : '';
  if (id && presets[id] && presets[id].boxes && presets[id].boxes.length) return presets[id];
  var handle = typeof window.lcProductHandle === 'string' ? window.lcProductHandle : '';
  if (handle && presets[handle] && presets[handle].boxes && presets[handle].boxes.length) return presets[handle];
  if (presets.default && presets.default.boxes && presets.default.boxes.length) return presets.default;
  return null;
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.lcApplyDomUi === 'function') window.lcApplyDomUi();

let isPinching = false;

var lcPreset = pickLcPresetFromWindow();
window.lcPreset = lcPreset;

var b0 = lcPreset && lcPreset.boxes[0] ? lcPreset.boxes[0] : null;
var b1 = lcPreset && lcPreset.boxes[1] ? lcPreset.boxes[1] : null;
var b2 = lcPreset && lcPreset.boxes[2] ? lcPreset.boxes[2] : null;

function getPresetBox(i) {
  return lcPreset && lcPreset.boxes && lcPreset.boxes[i] ? lcPreset.boxes[i] : null;
}

function getCirclePresetBox() {
  if (!lcPreset || !lcPreset.boxes) return null;
  for (var i = 0; i < lcPreset.boxes.length; i++) {
    if (lcPreset.boxes[i].type === 'circle') return lcPreset.boxes[i];
  }
  return null;
}

function getCircleMetrics(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var b = getPresetBox(idx);
  return {
    cx: (b && b.circleCenterX != null) ? b.circleCenterX : circleCenterX,
    cy: (b && b.circleCenterY != null) ? b.circleCenterY : circleCenterY,
    radius: (b && b.circleRadius != null) ? b.circleRadius : circleRadius
  };
}

function getCircleFitZone(boxKey, sc) {
  var cg = getCircleMetrics(boxKey);
  var diam = cg.radius * 2 * 0.92;
  return {
    cx: cg.cx,
    cy: cg.cy,
    radius: cg.radius,
    width: Math.min(getBoxMaxWidth(boxKey) * sc, diam),
    height: Math.min(getBoxMaxHeight(boxKey) * sc, diam)
  };
}

function lcRelativeMediaKey(base, file) {
  var b = String(base || '').replace(/\\/g, '/').replace(/^\.\//, '');
  var f = String(file || '').replace(/^\.\//, '');
  if (b && b.charAt(b.length - 1) !== '/') b += '/';
  return b + f;
}

/** Thème Shopify : assets plats → lc-Chemin_avec_slashes_en_underscores.ext */
function resolveLcMediaUrl(path) {
  if (path == null || path === '') return path;
  var p = String(path).replace(/\\/g, '/');
  if (/^https?:\/\//i.test(p) || p.indexOf('//') === 0) return p;
  var base = (typeof window.lcMediaBaseUrl === 'string') ? window.lcMediaBaseUrl : '';
  if (!base) return p;
  if (base.charAt(base.length - 1) !== '/') base += '/';
  var rel = p.replace(/^\.\//, '');
  return base + 'lc-' + rel.replace(/\//g, '_');
}

function setMaskLayerSrc(el, maskPath) {
  if (!el || !maskPath) return;
  var candidates = [String(maskPath).replace(/\\/g, '/')];
  if (candidates[0].indexOf('/') < 0) {
    candidates.push('Garderie/' + candidates[0]);
    candidates.push('lecolier/' + candidates[0]);
  }
  candidates = candidates.map(function (c) { return resolveLcMediaUrl(c); });
  var idx = 0;
  function tryNext() {
    if (idx >= candidates.length) return;
    el.onerror = function () {
      idx++;
      tryNext();
    };
    el.onload = function () {
      el.onerror = null;
    };
    var src = candidates[idx];
    lcApplyImageCrossOrigin(el, src);
    el.src = lcMediaUrlNoCache(src);
  }
  tryNext();
}

function isCircleBoxKey(boxKey) {
  if (!boxKey) return false;
  var idx = parseInt(boxKey.slice(3), 10) - 1;
  var b = getPresetBox(idx);
  return !!(b && b.type === 'circle');
}

function isFreePresetBox(idx) {
  var b = getPresetBox(idx);
  return !!(b && b.type !== 'circle');
}

function getBoxScale(boxKey) {
  if (boxKey === 'box2') return scaleFactor2;
  if (boxKey === 'box3') return scaleFactor3;
  return scaleFactor;
}

function setBoxScale(boxKey, v) {
  if (boxKey === 'box2') scaleFactor2 = v;
  else if (boxKey === 'box3') scaleFactor3 = v;
  else scaleFactor = v;
}

function getBoxXY(boxKey) {
  if (boxKey === 'box2') return { x: xPos2, y: yPos2 };
  if (boxKey === 'box3') return { x: xPos3, y: yPos3 };
  return { x: xPos, y: yPos };
}

function setBoxXY(boxKey, x, y) {
  if (boxKey === 'box2') { xPos2 = x; yPos2 = y; }
  else if (boxKey === 'box3') { xPos3 = x; yPos3 = y; }
  else { xPos = x; yPos = y; }
}

function getBoxMaxWidth(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var b = getPresetBox(idx);
  if (b && b.boxWidth != null) return b.boxWidth;
  if (boxKey === 'box2') return maxTextWidth2;
  if (boxKey === 'box3') return maxTextWidth3;
  return maxTextWidth1;
}

function getBoxMaxHeight(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var b = getPresetBox(idx);
  if (b && b.boxHeight != null) return b.boxHeight;
  if (boxKey === 'box2') return maxTextHeight2;
  if (boxKey === 'box3') return maxTextHeight3;
  return maxTextHeight1;
}

function getBoxMargins(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var b = getPresetBox(idx);
  var defaults = [
    { left: 10, right: 10, top: 0, bottom: 260 },
    { left: 47, right: 300, top: 335, bottom: 70 },
    { left: 10, right: 10, top: 0, bottom: 260 }
  ];
  var fb = defaults[idx] || defaults[0];
  return {
    left: (b && b.leftMargin != null) ? b.leftMargin : fb.left,
    right: (b && b.rightMargin != null) ? b.rightMargin : fb.right,
    top: (b && b.topMargin != null) ? b.topMargin : fb.top,
    bottom: (b && b.bottomMargin != null) ? b.bottomMargin : fb.bottom
  };
}

/** Centre la zone de texte (ancre centrale) au milieu du rectangle de marges. */
function computeCenterAnchorPosInMargins(boxKey, logicalW, logicalH, sc, fontSize) {
  var m = getBoxMargins(boxKey);
  var cx = (logicalW + m.left - m.right) / 2;
  var cy = (logicalH + m.top - m.bottom) / 2;
  var w = getBoxMaxWidth(boxKey) * sc;
  var h = getBoxMaxHeight(boxKey) * sc;
  var zoneTop = cy - h / 2;
  return { x: cx, y: zoneTop };
}

function getBoxFontSize(boxKey) {
  if (boxKey === 'box2') return currentFontSize2;
  if (boxKey === 'box3') return currentFontSize3;
  return currentFontSize;
}

function setBoxFontSize(boxKey, v) {
  if (boxKey === 'box2') currentFontSize2 = v;
  else if (boxKey === 'box3') currentFontSize3 = v;
  else currentFontSize = v;
}

function setBoxBBox(boxKey, bbox) {
  if (boxKey === 'box2') textBoundingBox2 = bbox;
  else if (boxKey === 'box3') textBoundingBox3 = bbox;
  else textBoundingBox = bbox;
}

function getBoxBBox(boxKey) {
  if (boxKey === 'box2') return textBoundingBox2;
  if (boxKey === 'box3') return textBoundingBox3;
  return textBoundingBox;
}

function clampCircleTextPos(boxKey, newPivotX, newPivotY) {
  var sc = getBoxScale(boxKey);
  var zone = getCircleFitZone(boxKey, sc);
  var cg = getCircleMetrics(boxKey);
  var align = getCircleTextAlign(boxKey);
  var zoneLeft = zoneLeftFromPivotX(newPivotX, zone.width, align);
  var ctx = getPreviewContext();
  var textHeight = zone.height;
  var padTopCircle = 0;
  var textW = zone.width;
  if (ctx && typeof fitTextToFixedZone === 'function') {
    var texts = getPreviewTexts();
    var fit3 = fitTextToFixedZone(ctx, texts.text1, texts.text2, texts.font, initialFontSize * sc, zone.width, zone.height, 8);
    padTopCircle = Math.max(0, (zone.height - fit3.totalH) * 0.5);
    textHeight = padTopCircle + fit3.totalH;
    textW = Math.max(fit3.w1, fit3.w2);
  }
  var circleLeft = cg.cx - zone.radius;
  var circleRight = cg.cx + zone.radius;
  var blockLeft = textBlockLeftFromPivot(newPivotX, zone.width, textW, align);
  var maxBlockLeft = circleRight - textW;
  var minBlockLeft = circleLeft;
  if (maxBlockLeft < minBlockLeft) maxBlockLeft = minBlockLeft;
  var newBlockLeft = clamp(blockLeft, minBlockLeft, maxBlockLeft);
  var newTextTop = clamp(newPivotY, cg.cy - zone.radius, cg.cy + zone.radius - textHeight);
  return {
    x: Math.round(pivotFromTextBlockLeft(newBlockLeft, textW, align)),
    y: Math.round(newTextTop)
  };
}

function canvasTextAlignFromChoice(align) {
  return align === 'right' ? 'right' : align === 'center' ? 'center' : 'left';
}

function zoneLeftFromPivotX(pivotX, zoneWidth, align) {
  if (align === 'right') return pivotX - zoneWidth;
  if (align === 'center') return pivotX - zoneWidth / 2;
  return pivotX;
}

function zoneXFromAlign(zoneLeft, zoneWidth, align) {
  if (align === 'right') return zoneLeft + zoneWidth;
  if (align === 'center') return zoneLeft + zoneWidth / 2;
  return zoneLeft;
}

function textBlockLeftInZone(zoneLeft, zoneWidth, textWidth, align) {
  if (align === 'center') return zoneLeft + (zoneWidth - textWidth) / 2;
  if (align === 'right') return zoneLeft + zoneWidth - textWidth;
  return zoneLeft;
}

function textBlockLeftFromPivot(pivotX, zoneW, textW, align) {
  var zoneLeft = zoneLeftFromPivotX(pivotX, zoneW, align);
  return textBlockLeftInZone(zoneLeft, zoneW, textW, align);
}

function pivotFromTextBlockLeft(blockLeft, textW, align) {
  if (align === 'right') return blockLeft + textW;
  if (align === 'center') return blockLeft + textW / 2;
  return blockLeft;
}

function getActiveCategoryId() {
  var ab = document.querySelector('.category-btn.active');
  return ab ? ab.dataset.category : (presetCategoryIds && presetCategoryIds[0]) ? presetCategoryIds[0] : 'divers';
}

function isUniCategoryMode() {
  return getActiveCategoryId() === 'uni';
}

function syncAlignButtons(align) {
  document.querySelectorAll('.align-button').forEach(function (btn) {
    btn.classList.toggle('active', btn.getAttribute('data-align') === align);
  });
}

var uniCategoryState = null;
var sharedCategoryState = null;
var needInitUniCategory = false;

function presetHasUniCategory() {
  return presetCategoryIds.indexOf('uni') >= 0;
}

function captureAllBoxState() {
  var state = { textAlign: textAlign, boxes: {} };
  for (var i = 0; i < lcBoxCount; i++) {
    var key = 'box' + (i + 1);
    var pos = getBoxXY(key);
    state.boxes[key] = { x: pos.x, y: pos.y, scale: getBoxScale(key) };
  }
  return state;
}

function applyAllBoxState(state) {
  if (!state || !state.boxes) return;
  for (var i = 0; i < lcBoxCount; i++) {
    var key = 'box' + (i + 1);
    var b = state.boxes[key];
    if (b) {
      setBoxXY(key, b.x, b.y);
      if (b.scale != null) setBoxScale(key, b.scale);
    }
  }
}

function isValidBoxState(state) {
  if (!state || !state.boxes) return false;
  for (var i = 0; i < lcBoxCount; i++) {
    var key = 'box' + (i + 1);
    var b = state.boxes[key];
    if (!b || isNaN(b.x) || isNaN(b.y)) return false;
  }
  return true;
}

function resetBoxesFromPreset() {
  if (b0) {
    if (b0.x != null) xPos = b0.x;
    if (b0.y != null) yPos = b0.y;
    if (b0.scale != null) scaleFactor = b0.scale;
  }
  if (b1) {
    if (b1.x != null) xPos2 = b1.x;
    if (b1.y != null) yPos2 = b1.y;
    if (b1.scale != null) scaleFactor2 = b1.scale;
  }
  if (b2) {
    if (b2.x != null) xPos3 = b2.x;
    if (b2.y != null) yPos3 = b2.y;
    if (b2.scale != null) scaleFactor3 = b2.scale;
  }
}

function resetCanvasEditToPreset() {
  resetBoxesFromPreset();
  for (var ri = 0; ri < lcBoxCount; ri++) {
    clampBoxScaleToTextFit('box' + (ri + 1));
  }
  updatePreview();
}

function initAllCircleBoxesCenter() {
  for (var i = 0; i < lcBoxCount; i++) {
    var presetBox = getPresetBox(i);
    if (!presetBox || presetBox.type !== 'circle') continue;
    var key = 'box' + (i + 1);
    var sc = getBoxScale(key);
    var zone = getCircleFitZone(key, sc);
    var cg = getCircleMetrics(key);
    var align = getCircleTextAlign(key);
    var textTop = cg.cy - zone.height / 2;
    var ctx = getPreviewContext();
    if (ctx && typeof fitTextToFixedZone === 'function') {
      var texts = getPreviewTexts();
      var fit = fitTextToFixedZone(ctx, texts.text1, texts.text2, texts.font, initialFontSize * sc, zone.width, zone.height, 8);
      textTop = cg.cy - fit.totalH / 2;
    }
    setBoxXY(key, zoneXFromAlign(cg.cx - zone.width / 2, zone.width, align), textTop);
  }
}

function initAllFreeBoxesUniCenter(logicalW, logicalH, fontSize) {
  for (var i = 0; i < lcBoxCount; i++) {
    if (!isFreePresetBox(i)) continue;
    var key = 'box' + (i + 1);
    var sc = getBoxScale(key);
    var centered = computeCenterAnchorPosInMargins(key, logicalW, logicalH, sc, fontSize);
    setBoxXY(key, centered.x, centered.y);
  }
}

function handleUniCategorySwitch(category, prevCat) {
  if (!presetHasUniCategory()) return;
  if (category === 'uni') {
    if (prevCat !== 'uni') {
      sharedCategoryState = captureAllBoxState();
    }
    if (isValidBoxState(uniCategoryState)) {
      applyAllBoxState(uniCategoryState);
      textAlign = uniCategoryState.textAlign || 'center';
      syncAlignButtons(textAlign);
    } else {
      needInitUniCategory = true;
      textAlign = 'center';
      syncAlignButtons('center');
    }
  } else if (prevCat === 'uni') {
    uniCategoryState = captureAllBoxState();
    textAlign = (lcPreset && lcPreset.defaultTextAlign) ? lcPreset.defaultTextAlign : 'left';
    syncAlignButtons(textAlign);
    if (isValidBoxState(sharedCategoryState)) {
      applyAllBoxState(sharedCategoryState);
    } else {
      resetBoxesFromPreset();
    }
  }
}

function convertPivotOnAlignChange(oldAlign, newAlign, pivotX, zoneW) {
  var zoneLeft = zoneLeftFromPivotX(pivotX, zoneW, oldAlign || 'left');
  return Math.round(zoneXFromAlign(zoneLeft, zoneW, newAlign || 'left'));
}

function getBoxTextAlign(boxKey, globalAlignOverride) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var presetBox = getPresetBox(idx);
  var presetDefault = lcPreset && lcPreset.defaultTextAlign ? lcPreset.defaultTextAlign : '';
  var global = globalAlignOverride != null ? globalAlignOverride : textAlign;
  if (window.LCPresetUtils && window.LCPresetUtils.resolveBoxTextAlign) {
    return window.LCPresetUtils.resolveBoxTextAlign(presetBox, presetDefault, global, lcBoxCount > 1, isUniCategoryMode());
  }
  if (isUniCategoryMode() && !isCircleBoxKey(boxKey)) return 'center';
  if (isCircleBoxKey(boxKey)) {
    if (lcBoxCount <= 1 && global) return global;
    if (presetBox && presetBox.textAlign) return presetBox.textAlign;
    return 'center';
  }
  if (global) return global;
  if (presetBox && presetBox.textAlign) return presetBox.textAlign;
  if (presetDefault) return presetDefault;
  return 'left';
}

function convertAllBoxPivotsOnAlignChange(oldGlobalAlign, newGlobalAlign) {
  for (var i = 0; i < lcBoxCount; i++) {
    var key = 'box' + (i + 1);
    var oldAlign = getBoxTextAlign(key, oldGlobalAlign);
    var newAlign = getBoxTextAlign(key, newGlobalAlign);
    if (oldAlign === newAlign) continue;
    var pos = getBoxXY(key);
    var sc = getBoxScale(key);
    var zoneW = isCircleBoxKey(key)
      ? getCircleFitZone(key, sc).width
      : getBoxMaxWidth(key) * sc;
    var newPivotX = convertPivotOnAlignChange(oldAlign, newAlign, pos.x, zoneW);
    setBoxXY(key, newPivotX, pos.y);
  }
}

function getCircleTextAlign(boxKey) {
  if (boxKey) return getBoxTextAlign(boxKey);
  for (var ci = 0; ci < lcBoxCount; ci++) {
    var cKey = 'box' + (ci + 1);
    if (isCircleBoxKey(cKey)) return getBoxTextAlign(cKey);
  }
  if (lcPreset && lcPreset.defaultTextAlign) return lcPreset.defaultTextAlign;
  if (lcBoxCount === 1 && isCircleBoxKey('box1')) return textAlign;
  return 'center';
}

var circlePreset = getCirclePresetBox();

var leftMargin = (b0 && b0.leftMargin != null) ? b0.leftMargin : 10;
var rightMargin = (b0 && b0.rightMargin != null) ? b0.rightMargin : 10;
var topMargin = (b0 && b0.topMargin != null) ? b0.topMargin : 0;
var bottomMargin = (b0 && b0.bottomMargin != null) ? b0.bottomMargin : 260;

let xPos = b0 ? b0.x : 20;
let yPos = b0 ? b0.y : 80;
let scaleFactor = b0 && b0.scale != null ? b0.scale : 1;
let isDragging = false;
let dragStartX = 0, dragStartY = 0;
let initialPinchDistance = null;
let initialScaleFactor = scaleFactor;

var leftMargin2 = (b1 && b1.leftMargin != null) ? b1.leftMargin : 47;
var rightMargin2 = (b1 && b1.rightMargin != null) ? b1.rightMargin : 300;
var topMargin2 = (b1 && b1.topMargin != null) ? b1.topMargin : 335;
var bottomMargin2 = (b1 && b1.bottomMargin != null) ? b1.bottomMargin : 70;

let xPos2 = b1 ? b1.x : 47;
let yPos2 = b1 ? b1.y : 360;
let scaleFactor2 = (b1 && b1.scale != null) ? b1.scale : 0.4;
let textBoundingBox2 = { x: xPos2, y: yPos2, width: 0, height: 0 };
let currentFontSize = 0;
let currentFontSize2 = 0;

var circleCenterX = (circlePreset && circlePreset.circleCenterX != null) ? circlePreset.circleCenterX : 352;
var circleCenterY = (circlePreset && circlePreset.circleCenterY != null) ? circlePreset.circleCenterY : 387;
var circleRadius = (circlePreset && circlePreset.circleRadius != null) ? circlePreset.circleRadius : 105;
let xPos3 = b2 ? b2.x : (circlePreset ? circlePreset.x : 280);
let yPos3 = b2 ? b2.y : (circlePreset ? circlePreset.y : 360);
let scaleFactor3 = (b2 && b2.scale != null) ? b2.scale : ((circlePreset && circlePreset.scale != null) ? circlePreset.scale : 0.5);
let currentFontSize3 = 0;
let textBoundingBox3 = { x: 0, y: 0, width: 0, height: 0 };

var lcBoxCount = lcPreset && lcPreset.boxes ? lcPreset.boxes.length : 3;

var maxTextWidth1 = (b0 && b0.boxWidth != null) ? b0.boxWidth : 300;
var maxTextWidth2 = (b1 && b1.boxWidth != null) ? b1.boxWidth : 300;
var maxTextWidth3 = (circlePreset && circlePreset.boxWidth != null) ? circlePreset.boxWidth : 300;
var DEFAULT_TEXT_BOX_HEIGHT = 168;
var maxTextHeight1 = (b0 && b0.boxHeight != null) ? b0.boxHeight : DEFAULT_TEXT_BOX_HEIGHT;
var maxTextHeight2 = (b1 && b1.boxHeight != null) ? b1.boxHeight : DEFAULT_TEXT_BOX_HEIGHT;
var maxTextHeight3 = (circlePreset && circlePreset.boxHeight != null) ? circlePreset.boxHeight : DEFAULT_TEXT_BOX_HEIGHT;

// Etat d'interaction
let activeDrag = null;    // 'box1' | 'box2' | 'box3' | null
let pinchTarget = null;   // 'box1' | 'box2' | 'box3' | null
let selectedEditBox = null; // textbox sélectionné en mode édition
let lastEditBoxSelectAt = 0;
const EDIT_WHEEL_GUARD_MS = 300;
const EDIT_MAX_ZOOM = 4;
const PREVIEW_LOGICAL_WIDTH = 500;
/** Marge intérieure zones libres — ancrage haut-gauche (state1 = centrage vertical dans le rect). */
var FREE_BOX_TEXT_INSET = 2;
const EDIT_HIGH_RES_MAX_WIDTH = 2400;
let canvasPixelScale = 1;
let previewLogicalWidth = PREVIEW_LOGICAL_WIDTH;
let previewLogicalHeight = PREVIEW_LOGICAL_WIDTH;
let modelNativeWidth = 0;
let modelNativeHeight = 0;
var orientedModelCache = { key: '', width: 0, height: 0, bitmap: null, drawFallback: null };
var previewLoadGen = 0;
var previewImageLoadGen = 0;
var previewPaintDoneLoadGen = 0;
var previewReadyForPdf = false;
// Appui long 1 s pour activer le déplacement (éviter de déplacer par erreur)
let longPressTimeout = null;
let pendingDragTarget = null;  // 'box1' | 'box2' | 'box3' | null
const LONG_PRESS_MS = 1000;	  
	  
	  
	  
let textBoundingBox = { x: xPos, y: yPos, width: 0, height: 0 };

function getModelColors(modelFileName) {
    var fallback = ['#000000', '#FF1493', '#1E90FF', '#FFD700'];
    var colors;
    if (window.LCPresetUtils && window.LCPresetUtils.getColorsForModel) {
        colors = window.LCPresetUtils.getColorsForModel(lcPreset, modelFileName);
    } else {
        var fb = window.LC_MODEL_COLORS || {};
        if (window.LCPresetUtils && window.LCPresetUtils.lookupLegacyColors) {
            colors = window.LCPresetUtils.lookupLegacyColors(modelFileName, fb);
        }
        if (!colors || !colors.length) {
            colors = (fb[modelFileName] && fb[modelFileName].length) ? fb[modelFileName].slice() : null;
        }
    }
    return colors && colors.length ? colors : fallback;
}

// Change from const to let
let imageBaseUrl = './Kit/Divers/';
	
const imageBaseUrlDivers = './Kit/Divers/';
const imageBaseUrlSport = './Kit/Sport/';
const imageBaseUrlAnimaux = './Kit/Animaux/';
const imageBaseUrlUni = './Kit/Uni/';
const imageBaseUrlCHSLD = './Kit/CHSLD/';
	
	
	const fontUrl = './fonts/mvboli.ttf'; // Local font file

    // Variables to store user choices
    let selectedModel = 'kit_NEW_cupcake_2024.jpg'; // Default selected model
    window.lcSelectedModel = selectedModel;
    let selectedColor = ''; // Track the selected color
    let selectedFont = 'Helvetica'; // Default selected font
    let textAlign = (lcPreset && lcPreset.defaultTextAlign) ? lcPreset.defaultTextAlign : 'left'; // Default text alignment
    if (lcBoxCount === 1 && lcPreset && lcPreset.boxes[0] && lcPreset.boxes[0].textAlign) {
      textAlign = lcPreset.boxes[0].textAlign;
    }

    function normalizeAllowedColors(raw) {
      var fallback = (window.LCPresetUtils && window.LCPresetUtils.DEFAULT_COLORS)
        ? window.LCPresetUtils.DEFAULT_COLORS.slice()
        : ['#000000', '#FF1493', '#1E90FF', '#FFD700'];
      if (!raw) return fallback;
      var list = Array.isArray(raw) ? raw : [raw];
      list = list.map(function (c) {
        if (window.LCPresetUtils && window.LCPresetUtils.parseColorEntry) {
          return window.LCPresetUtils.parseColorEntry(c).hex;
        }
        return String(c || '').trim();
      }).filter(function (c) {
        return c && (c.charAt(0) === '#' || /^rgb/i.test(c));
      });
      return list.length ? list : fallback;
    }

    function updateColorSwatches(modelFileName) {
      var root = document.querySelector('.lc-label-customizer.lc-shopify-embed') || document.querySelector('.lc-label-customizer');
      var swatchesContainer = root
        ? root.querySelector('#colorSwatches')
        : document.getElementById('colorSwatches');
      if (!swatchesContainer) return;
      swatchesContainer.innerHTML = '';
      var allowedColors = normalizeAllowedColors(getModelColors(modelFileName || selectedModel));
      var activeColor = selectedColor;
      if (!activeColor || allowedColors.indexOf(activeColor) === -1) {
        activeColor = allowedColors.length ? allowedColors[0] : '';
      }
      selectedColor = activeColor;
      allowedColors.forEach(function (color) {
        // button, not div — Toytime base.css hides empty divs (div:empty { display: none })
        var swatch = document.createElement('button');
        swatch.type = 'button';
        swatch.classList.add('lc-color-swatch', 'color-swatch');
        swatch.setAttribute('aria-label', lcColorDisplayName(color, modelFileName));
        swatch.setAttribute('aria-pressed', color === activeColor ? 'true' : 'false');
        swatch.style.backgroundColor = color;
        if (color === activeColor) swatch.classList.add('active');
        swatch.addEventListener('click', function () {
          if (swatch.classList.contains('active')) {
            selectedColor = color;
            updatePreview();
            return;
          }
          var prev = swatchesContainer.querySelector('.color-swatch.active');
          if (prev) {
            prev.classList.remove('active');
            prev.setAttribute('aria-pressed', 'false');
          }
          swatch.classList.add('active');
          swatch.setAttribute('aria-pressed', 'true');
          selectedColor = color;
          updatePreview();
          swatch.blur();
        });
        swatchesContainer.appendChild(swatch);
      });
    }

    window.lcPaintColorSwatches = function () {
      updateColorSwatches(selectedModel);
    };

    // Define the thumbnails after the DOM has fully loaded
    const thumbnails = document.querySelectorAll('.model-thumbnail');

    // Text box configurations based on the provided values
    let xStart = 20; // Initial X position for the text box
    let yStartLine1 = 80; // Initial Y position for the first line in the draggable box
    const lineSpacing = 8;
    function lineSpacingForFontSize(fontSize) {
      return lineSpacing * (fontSize / initialFontSize);
    }
    let initialFontSize = 80; // Updated initial larger font size

    function getMaxTextWidth(isTwo) {
      return isTwo ? maxTextWidth2 : maxTextWidth1;
    }

    function getMaxTextHeight(isTwo) {
      if (isTwo === 3 || isTwo === 'circle') return maxTextHeight3;
      return isTwo ? maxTextHeight2 : maxTextHeight1;
    }

    function fixedTextZoneHeight(isTwo, sc) {
      return getMaxTextHeight(isTwo) * sc;
    }

    function clampFreeBoxPosByKey(boxKey, pivotX, pivotY, sc) {
      var align = getBoxTextAlign(boxKey);
      var w = getBoxMaxWidth(boxKey) * sc;
      var h = getBoxMaxHeight(boxKey) * sc;
      var zoneLeft = zoneLeftFromPivotX(pivotX, w, align);
      var m = getBoxMargins(boxKey);
      var ctx = getPreviewContext();
      if (!ctx || typeof fitTextToFixedZone !== 'function') {
        var newLeftFb = clamp(zoneLeft, m.left, previewLogicalWidth - m.right - w);
        var newTopFb = clamp(pivotY, m.top, previewLogicalHeight - m.bottom - h);
        return {
          x: zoneXFromAlign(newLeftFb, w, align),
          y: newTopFb
        };
      }
      var texts = getPreviewTexts();
      var fit = fitTextToFixedZone(ctx, texts.text1, texts.text2, texts.font, initialFontSize * sc, w, h);
      var textW = Math.max(fit.w1, fit.w2);
      var blockH = FREE_BOX_TEXT_INSET + fit.totalH;
      var zoneBottomLimit = previewLogicalHeight - m.bottom;
      var maxPivotY = zoneBottomLimit - blockH;
      var minPivotY = m.top;
      if (maxPivotY < minPivotY) maxPivotY = minPivotY;
      var blockLeft = textBlockLeftFromPivot(pivotX, w, textW, align);
      var maxBlockLeft = previewLogicalWidth - m.right - textW;
      var minBlockLeft = m.left;
      if (maxBlockLeft < minBlockLeft) maxBlockLeft = minBlockLeft;
      var newBlockLeft = clamp(blockLeft, minBlockLeft, maxBlockLeft);
      var newTextTop = clamp(pivotY, minPivotY, maxPivotY);
      return {
        x: Math.round(pivotFromTextBlockLeft(newBlockLeft, textW, align)),
        y: newTextTop
      };
    }

    function clampPosToTextMargins(isTwo, pivotX, pivotY, sc) {
      return clampFreeBoxPosByKey(isTwo ? 'box2' : 'box1', pivotX, pivotY, sc);
    }

    function measureTwoLineLayout(ctx, text1, text2, fontSize, fontFamily, spacing) {
      var mctx = getPreviewContext() || getMeasureContext();
      mctx.save();
      if (mctx.setTransform) mctx.setTransform(1, 0, 0, 1, 0, 0);
      mctx.font = fontSize + 'px ' + fontFamily;
      var m1 = mctx.measureText(text1);
      var m2 = mctx.measureText(text2);
      mctx.restore();
      var a1 = m1.actualBoundingBoxAscent > 0 ? m1.actualBoundingBoxAscent : fontSize * 0.82;
      var d1 = m1.actualBoundingBoxDescent > 0 ? m1.actualBoundingBoxDescent : fontSize * 0.18;
      var a2 = m2.actualBoundingBoxAscent > 0 ? m2.actualBoundingBoxAscent : fontSize * 0.82;
      var d2 = m2.actualBoundingBoxDescent > 0 ? m2.actualBoundingBoxDescent : fontSize * 0.18;
      var totalH = a1 + d1 + spacing + a2 + d2;
      return { w1: m1.width, w2: m2.width, a1: a1, d1: d1, a2: a2, d2: d2, totalH: totalH };
    }

    function zoneTextFitsLayout(layout, zoneW, zoneH, inset) {
      inset = inset != null ? inset : FREE_BOX_TEXT_INSET;
      var maxW = Math.max(0, zoneW - inset);
      var maxH = Math.max(0, zoneH - inset);
      return layout.w1 <= maxW && layout.w2 <= maxW && layout.totalH <= maxH;
    }

    function getTextFitMode() {
      var preset = lcPreset || window.lcPreset;
      if (preset && preset.textFitMode === 'uniform') return 'uniform';
      return 'perLine';
    }

    function measureSingleLine(ctx, text, fontSize, fontFamily) {
      var mctx = getPreviewContext() || getMeasureContext();
      mctx.save();
      if (mctx.setTransform) mctx.setTransform(1, 0, 0, 1, 0, 0);
      mctx.font = fontSize + 'px ' + fontFamily;
      var m = mctx.measureText(text);
      mctx.restore();
      var a = m.actualBoundingBoxAscent > 0 ? m.actualBoundingBoxAscent : fontSize * 0.82;
      var d = m.actualBoundingBoxDescent > 0 ? m.actualBoundingBoxDescent : fontSize * 0.18;
      return { fontSize: fontSize, w: m.width, a: a, d: d, h: a + d };
    }

    function singleLineFitsInBand(ctx, text, font, fontSize, maxW, maxLineH) {
      var line = measureSingleLine(ctx, text, fontSize, font);
      return line.w <= maxW && line.h <= maxLineH;
    }

    /** Plus grande taille qui tient en largeur + hauteur (recherche binaire, pas plafonnée à startSize). */
    function fitSingleLineMaxFont(ctx, text, font, startSize, zoneW, maxLineH, minSize) {
      if (!text) return { fontSize: 0, w: 0, a: 0, d: 0, h: 0 };
      var inset = 2;
      var maxW = Math.max(0, zoneW - inset);
      var absMin = 1;
      var capMin = minSize != null ? minSize : 10;
      minSize = Math.min(capMin, Math.max(absMin, Math.floor(Math.min(zoneW, maxLineH) * 0.12)));
      maxLineH = Math.max(1, maxLineH);

      var lo = minSize;
      var hi = Math.max(startSize, maxLineH * 1.15, maxW);
      while (singleLineFitsInBand(ctx, text, font, hi, maxW, maxLineH) && hi < 2400) {
        hi *= 1.35;
      }
      if (!singleLineFitsInBand(ctx, text, font, hi, maxW, maxLineH)) {
        var best = lo;
        for (var i = 0; i < 28; i++) {
          var mid = (lo + hi) / 2;
          if (singleLineFitsInBand(ctx, text, font, mid, maxW, maxLineH)) {
            best = mid;
            lo = mid;
          } else {
            hi = mid;
          }
        }
        return measureSingleLine(ctx, text, best, font);
      }
      return measureSingleLine(ctx, text, hi, font);
    }

    function fitFontToFixedZonePerLine(ctx, text1, text2, font, startSize, zoneW, zoneH, minSize) {
      var inset = 2;
      var innerW = zoneW;
      var innerH = Math.max(0, zoneH - inset);
      var has1 = !!(text1 && String(text1).length);
      var has2 = !!(text2 && String(text2).length);
      if (!has1 && !has2) {
        return {
          fontSize: 0, fontSize1: 0, fontSize2: 0, lineSpacing: 0,
          w1: 0, w2: 0, a1: 0, d1: 0, a2: 0, d2: 0, totalH: 0, mode: 'perLine'
        };
      }
      if (!has1 || !has2) {
        var lone = has1 ? text1 : text2;
        var s = fitSingleLineMaxFont(ctx, lone, font, startSize, innerW, innerH, minSize);
        return {
          fontSize: s.fontSize,
          fontSize1: has1 ? s.fontSize : 0,
          fontSize2: has2 ? s.fontSize : 0,
          lineSpacing: 0,
          w1: has1 ? s.w : 0,
          w2: has2 ? s.w : 0,
          a1: has1 ? s.a : 0,
          d1: has1 ? s.d : 0,
          a2: has2 ? s.a : 0,
          d2: has2 ? s.d : 0,
          totalH: s.h,
          mode: 'perLine'
        };
      }

      var l1;
      var l2;
      var spacing = lineSpacingForFontSize(startSize);
      var fs1;
      var fs2;
      for (var iter = 0; iter < 3; iter++) {
        spacing = lineSpacingForFontSize(iter === 0 ? startSize : Math.min(fs1, fs2));
        var halfH = Math.max(1, (innerH - spacing) / 2);
        l2 = fitSingleLineMaxFont(ctx, text2, font, startSize, innerW, halfH, minSize);
        var maxH1 = Math.max(1, innerH - spacing - l2.h);
        l1 = fitSingleLineMaxFont(ctx, text1, font, startSize, innerW, maxH1, minSize);
        fs1 = l1.fontSize;
        fs2 = l2.fontSize;
      }
      spacing = lineSpacingForFontSize(Math.min(fs1, fs2));
      var totalH = l1.h + spacing + l2.h;
      if (totalH > innerH && totalH > 0) {
        var scaleH = innerH / totalH;
        fs1 = Math.max(1, fs1 * scaleH);
        fs2 = Math.max(1, fs2 * scaleH);
        spacing = lineSpacingForFontSize(Math.min(fs1, fs2));
        l1 = measureSingleLine(ctx, text1, fs1, font);
        l2 = measureSingleLine(ctx, text2, fs2, font);
        totalH = l1.h + spacing + l2.h;
      }

      return {
        fontSize: Math.max(fs1, fs2),
        fontSize1: fs1,
        fontSize2: fs2,
        lineSpacing: spacing,
        w1: l1.w,
        w2: l2.w,
        a1: l1.a,
        d1: l1.d,
        a2: l2.a,
        d2: l2.d,
        totalH: totalH,
        mode: 'perLine'
      };
    }

    function fitTextToFixedZone(ctx, text1, text2, font, startSize, zoneW, zoneH, minSize) {
      if (getTextFitMode() === 'perLine') {
        return fitFontToFixedZonePerLine(ctx, text1, text2, font, startSize, zoneW, zoneH, minSize);
      }
      var fit = fitFontToFixedZone(ctx, text1, text2, font, startSize, zoneW, zoneH, minSize);
      return Object.assign({}, fit, {
        fontSize1: fit.fontSize,
        fontSize2: fit.fontSize,
        mode: 'uniform'
      });
    }

    function fillTextTwoLinesFromFit(ctx, fit, font, xAlign, baseline1, text1, text2) {
      var fs1 = fit.fontSize1 != null ? fit.fontSize1 : fit.fontSize;
      var fs2 = fit.fontSize2 != null ? fit.fontSize2 : fit.fontSize;
      if (text1) {
        ctx.font = fs1 + 'px ' + font;
        ctx.fillText(text1, xAlign, baseline1);
      }
      if (text2) {
        var baseline2 = baseline1 + fit.d1 + fit.lineSpacing + fit.a2;
        ctx.font = fs2 + 'px ' + font;
        ctx.fillText(text2, xAlign, baseline2);
      }
    }

    function fitFontToFixedZone(ctx, text1, text2, font, startSize, zoneW, zoneH, minSize) {
      var inset = 2;
      var absMin = 1;
      var capMin = minSize != null ? minSize : 10;
      minSize = Math.min(capMin, Math.max(absMin, Math.floor(Math.min(zoneW, zoneH) * 0.12)));

      var fontSize = Math.max(absMin, startSize);
      var spacing = lineSpacingForFontSize(fontSize);
      var layout = measureTwoLineLayout(ctx, text1, text2, fontSize, font, spacing);

      while (!zoneTextFitsLayout(layout, zoneW, zoneH, inset) && fontSize > absMin + 0.2) {
        fontSize -= fontSize > minSize ? 1 : 0.25;
        if (fontSize < absMin) fontSize = absMin;
        spacing = lineSpacingForFontSize(fontSize);
        layout = measureTwoLineLayout(ctx, text1, text2, fontSize, font, spacing);
      }

      if (!zoneTextFitsLayout(layout, zoneW, zoneH, inset)) {
        var maxW = Math.max(0, zoneW - inset);
        var maxH = Math.max(0, zoneH - inset);
        var scale = Math.min(
          maxW / Math.max(layout.w1, layout.w2, 1),
          maxH / Math.max(layout.totalH, 1),
          1
        );
        if (scale < 1) {
          fontSize = Math.max(absMin, fontSize * scale);
          spacing = lineSpacingForFontSize(fontSize);
          layout = measureTwoLineLayout(ctx, text1, text2, fontSize, font, spacing);
        }
      }

      return Object.assign({ fontSize: fontSize, lineSpacing: spacing }, layout);
    }

    /** Zone clip + bbox (cadres verts) — pivot = haut du rectangle (aligné haut-gauche). */
    function getFreeBoxZoneRect(boxKey, pos, sc, align, ctx, font) {
      var w = getBoxMaxWidth(boxKey) * sc;
      var h = getBoxMaxHeight(boxKey) * sc;
      var zoneLeft = zoneLeftFromPivotX(pos.x, w, align);
      return {
        left: zoneLeft,
        top: pos.y,
        width: w,
        height: h,
        pivotX: pos.x,
        pivotY: pos.y
      };
    }








    const previewCanvas = document.getElementById('previewCanvas');
	const context = previewCanvas.getContext('2d');
    const canvasBoundingBox = previewCanvas.getBoundingClientRect(); // Get canvas bounding box for boundaries

    // Padding configuration for all sides
    const canvasPaddingTop = 10; // Padding from the top
    const canvasPaddingLeft = 10; // Padding from the left
    const canvasPaddingRight = 10; // Padding from the right
    const canvasPaddingBottom = 10; // Padding from the bottom






const categories = {
	divers: [
		{ src: `${imageBaseUrlDivers}kit-sushi-JUIN07-2024.jpg`, value: 'kit-sushi-JUIN07-2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_agrumes_2024.jpg`, value: 'kit_agrumes_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_ananas_blue_2024.jpg`, value: 'kit_ananas_blue_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_ananas_mauve_2024.jpg`, value: 'kit_ananas_mauve_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_arc-en-ciel_2024.jpg`, value: 'kit_arc-en-ciel_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Astronaut_2024.jpg`, value: 'kit_Astronaut_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_beignet_2024.jpg`, value: 'kit_beignet_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_biscuit_2024.jpg`, value: 'kit_biscuit_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Boho_2024.jpg`, value: 'kit_Boho_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_bucheron_2024.jpg`, value: 'kit_bucheron_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_cactus bleu_2024.jpg`, value: 'kit_cactus bleu_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_cactus jaune_2024.jpg`, value: 'kit_cactus jaune_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_campeur_2024.jpg`, value: 'kit_campeur_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_camping_2024.jpg`, value: 'kit_camping_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_carnaval_2024.jpg`, value: 'kit_carnaval_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_champignon1_2024.jpg`, value: 'kit_champignon1_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_champignon2_2024.jpg`, value: 'kit_champignon2_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_coeur_2024.jpg`, value: 'kit_coeur_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_douceur_2024.jpg`, value: 'kit_douceur_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Douce_melodie_2024.jpg`, value: 'kit_Douce_melodie_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_ferme_2024.jpg`, value: 'kit_ferme_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_feuillus 2_2024.jpg`, value: 'kit_feuillus 2_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_finesse_2024.jpg`, value: 'kit_finesse_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_fleur_2024.jpg`, value: 'kit_fleur_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_fraises_2024.jpg`, value: 'kit_fraises_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_gamer rouge_2024.jpg`, value: 'kit_gamer rouge_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_gamer vert_2024.jpg`, value: 'kit_gamer vert_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_glacee_2024.jpg`, value: 'kit_glacee_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_insecte_2024.jpg`, value: 'kit_insecte_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_machienrie_2024.jpg`, value: 'kit_machienrie_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_magie_2024.jpg`, value: 'kit_magie_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Melon_2024.jpg`, value: 'kit_Melon_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_mer_2024.jpg`, value: 'kit_mer_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_motocross_2024.jpg`, value: 'kit_motocross_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_moustache_2024.jpg`, value: 'kit_moustache_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_NEW_cupcake_2024.jpg`, value: 'kit_NEW_cupcake_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_petite_foret_2024.jpg`, value: 'kit_petite_foret_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_princesse_2024.jpg`, value: 'kit_princesse_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_ptitmonstre_2024.jpg`, value: 'kit_ptitmonstre_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Souslocean_2024.jpg`, value: 'kit_Souslocean_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_superhero_2024.jpg`, value: 'kit_superhero_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_Tracteur_2024.jpg`, value: 'kit_Tracteur_2024.jpg' },
		{ src: `${imageBaseUrlDivers}kit_tropique_2024.jpg`, value: 'kit_tropique_2024.jpg' }
	],

	animaux: [
		{ src: `${imageBaseUrlAnimaux}kit_cameleon_2024-new.jpg`, value: 'kit_cameleon_2024-new.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_chat_2024.jpg`, value: 'kit_chat_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_cheval_2024.jpg`, value: 'kit_cheval_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_chien_2024.jpg`, value: 'kit_chien_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_cochon_2024.jpg`, value: 'kit_cochon_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_Dino Rose_2024.jpg`, value: 'kit_Dino Rose_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_dino vert_2024.jpg`, value: 'kit_dino vert_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_foret_2024.jpg`, value: 'kit_foret_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_herisson_2024.jpg`, value: 'kit_herisson_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_Koala_2024.jpg`, value: 'kit_Koala_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_Lapin-doux_2024.jpg`, value: 'kit_Lapin-doux_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_lapin_2024.jpg`, value: 'kit_lapin_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_licorne_2024.jpg`, value: 'kit_licorne_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_minou_2024.jpg`, value: 'kit_minou_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_NEW_flamant_2024.jpg`, value: 'kit_NEW_flamant_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_panda_2024.jpg`, value: 'kit_panda_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_paresseux_2024.jpg`, value: 'kit_paresseux_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_pitou_2024.jpg`, value: 'kit_pitou_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_Pug_2024.jpg`, value: 'kit_Pug_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_renard bleu_2024.jpg`, value: 'kit_renard bleu_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_renard rose_2024.jpg`, value: 'kit_renard rose_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_renard_2024.jpg`, value: 'kit_renard_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_savane_2024.jpg`, value: 'kit_savane_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_singe_2024.jpg`, value: 'kit_singe_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_sirene_2024.jpg`, value: 'kit_sirene_2024.jpg' },
		{ src: `${imageBaseUrlAnimaux}kit_tortue_2024.jpg`, value: 'kit_tortue_2024.jpg' }
	],

    sport: [
        { src: `${imageBaseUrlSport}kit_Ballerine A_2024.jpg`, value: 'kit_Ballerine A_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Ballerine B_2024.jpg`, value: 'kit_Ballerine B_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Baseball_2024.jpg`, value: 'kit_Baseball_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Hockey_2024.jpg`, value: 'kit_Hockey_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Skateboard_2024.jpg`, value: 'kit_Skateboard_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Soccer_2024.jpg`, value: 'kit_Soccer_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_Surf_2024.jpg`, value: 'kit_Surf_2024.jpg' },
        { src: `${imageBaseUrlSport}kit_voiture rose_2024.jpg`, value: 'kit_voiture rose_2024.jpg' }
    ],

    uni: [
        { src: `${imageBaseUrlUni}kit-blanc.jpg`, value: 'kit-blanc.jpg' },
        { src: `${imageBaseUrlUni}kit-camoufle.jpg`, value: 'kit-camoufle.jpg' },
        { src: `${imageBaseUrlUni}kit-cieldete.jpg`, value: 'kit-cieldete.jpg' },
        { src: `${imageBaseUrlUni}kit-lagrappe.jpg`, value: 'kit-lagrappe.jpg' },
        { src: `${imageBaseUrlUni}kit-lavague-new.jpg`, value: 'kit-lavague-new.jpg' },
        { src: `${imageBaseUrlUni}kit-leclatant.jpg`, value: 'kit-leclatant.jpg' },
        { src: `${imageBaseUrlUni}kit-Lefeuillus.jpg`, value: 'kit-Lefeuillus.jpg' },
        { src: `${imageBaseUrlUni}kit-letoile.jpg`, value: 'kit-letoile.jpg' },
        { src: `${imageBaseUrlUni}kit-locre.jpg`, value: 'kit-locre.jpg' },
        { src: `${imageBaseUrlUni}kit-lorangier.jpg`, value: 'kit-lorangier.jpg' },
        { src: `${imageBaseUrlUni}kit-rosee.jpg`, value: 'kit-rosee.jpg' }
    ],
    chsld: [
        { src: `${imageBaseUrlCHSLD}kit_marguerite_2024.jpg`, value: 'kit_marguerite_2024.jpg' },
        { src: `${imageBaseUrlCHSLD}kit_pivoine_2024.jpg`, value: 'kit_pivoine_2024.jpg' },
        { src: `${imageBaseUrlCHSLD}kit_poisoon_2024.jpg`, value: 'kit_poisoon_2024.jpg' },
		{ src: `${imageBaseUrlCHSLD}kit_Rosie_2024.jpg`, value: 'kit_Rosie_2024.jpg' },
		{ src: `${imageBaseUrlCHSLD}kit_voiture verte_2024.jpg`, value: 'kit_voiture verte_2024.jpg' }
    ]
};

    var maskLayerEl = document.getElementById('maskLayer');
    if (maskLayerEl && lcPreset && lcPreset.mask) setMaskLayerSrc(maskLayerEl, lcPreset.mask);

    var categoriesToUse = categories;
    var categoryBaseUrls = {};
    var presetCategoryIds = [];
    if (lcPreset && lcPreset.categories && lcPreset.categories.length > 0) {
        categoriesToUse = {};
        lcPreset.categories.forEach(function (cat) {
            var base = cat.baseUrl || '';
            var mods = (cat.models || []).map(function (m) {
                var v = typeof m === 'string' ? m : (m && (m.file || m.value));
                var colors = (typeof m === 'object' && m && m.colors && m.colors.length) ? m.colors : null;
                if (!colors && v && window.LCPresetUtils && window.LCPresetUtils.lookupLegacyColors) {
                    colors = window.LCPresetUtils.lookupLegacyColors(v, window.LC_MODEL_COLORS || {});
                }
                if (colors && window.LCPresetUtils && window.LCPresetUtils.colorListToHexArray) {
                    colors = window.LCPresetUtils.colorListToHexArray(colors);
                }
                return { src: resolveLcMediaUrl(lcRelativeMediaKey(base, v)), value: v, colors: colors };
            });
            if (cat.id) {
                categoriesToUse[cat.id] = mods;
                categoryBaseUrls[cat.id] = base;
                presetCategoryIds.push(cat.id);
            }
        });
    }

    var categoryButtonsContainer = document.getElementById('categoryButtons');
    if (categoryButtonsContainer && presetCategoryIds.length > 0) {
        categoryButtonsContainer.innerHTML = '';
        presetCategoryIds.forEach(function (id, idx) {
            var cat = lcPreset.categories[idx];
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'category-btn' + (idx === 0 ? ' active' : '');
            btn.dataset.category = id;
            btn.textContent = lcCategoryLabel(id, cat.name || id);
            categoryButtonsContainer.appendChild(btn);
        });
        if (presetCategoryIds.length) {
            imageBaseUrl = categoryBaseUrls[presetCategoryIds[0]] || imageBaseUrlDivers;
            selectedModel = (categoriesToUse[presetCategoryIds[0]] && categoriesToUse[presetCategoryIds[0]][0]) ? categoriesToUse[presetCategoryIds[0]][0].value : selectedModel;
            window.lcSelectedModel = selectedModel;
        }
    }

    var categoryButtons = document.querySelectorAll('.category-btn');
    const modelThumbnails = document.getElementById('modelThumbnails');

categoryButtons.forEach(button => {
    button.addEventListener('click', function () {
        const category = this.dataset.category;
        var prevCatEl = document.querySelector('.category-btn.active');
        var prevCat = prevCatEl ? prevCatEl.dataset.category : null;

        categoryButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        updateModelThumbnails(category);

        if (categoryBaseUrls[category] !== undefined) {
            imageBaseUrl = categoryBaseUrls[category] || './Kit/Divers/';
        } else {
            switch(category) {
                case 'divers': imageBaseUrl = imageBaseUrlDivers; break;
                case 'animaux': imageBaseUrl = imageBaseUrlAnimaux; break;
                case 'sport': imageBaseUrl = imageBaseUrlSport; break;
                case 'uni': imageBaseUrl = imageBaseUrlUni; break;
                case 'chsld': imageBaseUrl = imageBaseUrlCHSLD; break;
                default: imageBaseUrl = './Kit/Divers/';
            }
        }

        handleUniCategorySwitch(category, prevCat);

        updatePreview();
    });
});



function updateModelThumbnails(category) {
    modelThumbnails.innerHTML = '';
    var list = categoriesToUse[category];
    if (!list || !list.length) return;
    list.forEach(model => {
        const img = document.createElement('img');
        img.src = model.src;
        img.classList.add('model-thumbnail');
        img.dataset.model = model.value;
        img.addEventListener('click', function () {
            selectModel(this.dataset.model);  // Call selectModel here
        });
        modelThumbnails.appendChild(img);
    });

    const firstModel = document.querySelector('.model-thumbnail');
    if (firstModel) firstModel.click();
}

function selectModel(model) {
    selectedModel = model;
    window.lcSelectedModel = model;
    updateColorSwatches(selectedModel);
    syncFontButtonState(selectedFont);
    document.querySelectorAll('.model-thumbnail').forEach(function (img) {
        img.classList.toggle('selected', img.dataset.model === model);
    });
    updatePreview();
}


    var initialCategory = presetCategoryIds.length ? presetCategoryIds[0] : 'divers';
    updateModelThumbnails(initialCategory);
    if (!presetCategoryIds.length) imageBaseUrl = imageBaseUrlDivers;
    if (initialCategory === 'uni' && presetHasUniCategory()) {
        needInitUniCategory = true;
        textAlign = 'center';
        syncAlignButtons('center');
    }






document.addEventListener('scroll', function(event) {
    // Custom scroll handling code here if needed
}, { passive: true });


    // Prevent default behavior for the canvas and text box to avoid blue highlight
    previewCanvas.addEventListener('mousedown', function(event) {
        event.preventDefault(); // Prevent default selection behavior
    });






    // Function to update selected font and apply it to the preview
    function syncFontButtonState(font) {
        document.querySelectorAll('.font-button').forEach(function (button) {
            button.classList.remove('active');
            if (button.getAttribute('data-font') === font) {
                button.classList.add('active');
            }
        });
    }

    function updateFontSelection(font, skipPreview) {
        selectedFont = font;
        syncFontButtonState(font);
        if (!skipPreview) updatePreview();
    }

    // Function to update selected alignment and apply it to the preview
    function updateAlignmentSelection(alignment) {
        if (textAlign === alignment) return;
        convertAllBoxPivotsOnAlignChange(textAlign, alignment);
        textAlign = alignment;

        if (isUniCategoryMode()) {
            if (!uniCategoryState) uniCategoryState = captureAllBoxState();
            uniCategoryState.textAlign = alignment;
        }
        // Update active state for alignment buttons
        document.querySelectorAll('.align-button').forEach(button => {
            button.classList.remove('active');
            if (button.getAttribute('data-align') === alignment) {
                button.classList.add('active');
            }
        });

        updatePreview(); // Refresh preview with new alignment
    }



    // Event listener for font button click
    document.querySelectorAll('.font-button').forEach(button => {
        button.addEventListener('click', function () {
            const font = this.getAttribute('data-font');
            updateFontSelection(font); // Update font selection
        });
    });

    // Event listener for alignment button click
    document.querySelectorAll('.align-button').forEach(button => {
        button.addEventListener('click', function () {
            const alignment = this.getAttribute('data-align');
            updateAlignmentSelection(alignment); // Update alignment selection
        });
    });

    document.querySelectorAll('.align-button').forEach(function (btn) {
        btn.classList.toggle('active', btn.getAttribute('data-align') === textAlign);
    });

/*
    // Event listener for model thumbnail click
    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', function () {
            // Remove 'selected' class from all thumbnails
            thumbnails.forEach(img => img.classList.remove('selected'));

            // Add 'selected' class to clicked thumbnail
            this.classList.add('selected');

            // Update selected model
            selectedModel = this.dataset.model;

            // Update color swatches based on the selected model
            updateColorSwatches(selectedModel);

            // Refresh preview with new model and updated color options
            updatePreview();
        });
    });
*/



function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function sanitizeLabelText(str) {
  if (typeof LCPresetUtils !== 'undefined' && LCPresetUtils.sanitizeLabelText) {
    return LCPresetUtils.sanitizeLabelText(str);
  }
  return str == null ? '' : String(str);
}

function sanitizeLabelTextInput(el) {
  if (!el) return;
  var raw = el.value;
  var clean = sanitizeLabelText(raw);
  if (clean === raw) return;
  var start = el.selectionStart;
  el.value = clean;
  if (start != null && typeof start === 'number') {
    var pos = sanitizeLabelText(raw.slice(0, start)).length;
    el.setSelectionRange(pos, pos);
  }
}

function bindLabelTextField(el) {
  if (!el || el.dataset.lcTextSanitizeBound) return;
  el.dataset.lcTextSanitizeBound = '1';
  el.addEventListener('input', function () {
    sanitizeLabelTextInput(el);
    lcClearCartTextWarn();
    updatePreview();
  });
  el.addEventListener('paste', function () {
    requestAnimationFrame(function () {
      sanitizeLabelTextInput(el);
      updatePreview();
    });
  });
}

function getPreviewTexts() {
  var el1 = document.getElementById('customText1');
  var el2 = document.getElementById('customText2');
  return {
    text1: sanitizeLabelText((el1 && el1.value.trim()) || lcStr('firstName', 'Prénom')),
    text2: sanitizeLabelText((el2 && el2.value.trim()) || lcStr('lastNamePlaceholder', 'Nom de Famille')),
    font: selectedFont || 'Helvetica'
  };
}

/** Valeurs réelles des champs (sans placeholders preview) — line item properties Shopify. */
function getCartTextValues() {
  var el1 = document.getElementById('customText1');
  var el2 = document.getElementById('customText2');
  return {
    prenom: sanitizeLabelText((el1 && el1.value.trim()) || ''),
    nom: sanitizeLabelText((el2 && el2.value.trim()) || '')
  };
}

function lcClearCartTextWarn() {
  var warn = document.getElementById('lc-cart-text-warn');
  if (warn) warn.hidden = true;
}

/** Vrai texte saisi dans les champs — pas le placeholder de l’aperçu canvas. */
function lcCartHasRequiredText() {
  var el1 = document.getElementById('customText1');
  var el2 = document.getElementById('customText2');
  var v1 = sanitizeLabelText((el1 && el1.value.trim()) || '');
  var v2 = sanitizeLabelText((el2 && el2.value.trim()) || '');
  return !!(v1 || v2);
}

function lcExpandCustomizerSection(sectionId) {
  var section = document.querySelector('.dropdown-section[data-section="' + sectionId + '"]');
  if (!section) return;
  section.classList.remove('collapsed');
  var hdr = section.querySelector('.dropdown-header');
  if (hdr) hdr.setAttribute('aria-expanded', 'true');
}

function lcNotifyCartTextRequired() {
  var msg = lcStr('cartTextRequired', 'Saisissez votre prénom ou nom dans les champs « Texte ».');
  lcExpandCustomizerSection('texte');
  var warn = document.getElementById('lc-cart-text-warn');
  if (warn) {
    warn.textContent = msg;
    warn.hidden = false;
  } else {
    alert(msg);
  }
  var el1 = document.getElementById('customText1');
  var el2 = document.getElementById('customText2');
  var v1 = sanitizeLabelText((el1 && el1.value.trim()) || '');
  var v2 = sanitizeLabelText((el2 && el2.value.trim()) || '');
  if (el1 && !v1) {
    el1.focus();
    return;
  }
  if (el2 && !v2) {
    el2.focus();
    return;
  }
  if (el1) el1.focus();
}

/**
 * Line item properties envoyées au panier (voir aussi src/lc-shopify-cart.js).
 * Visibles panier : Prénom, Nom, Catégorie, Modèle, Police, Couleur (+ image via _LC Preview).
 * Masquées (_*) : technique, fichier JPG, vignette admin legacy, PDF, placement.
 */
function buildLineItemProperties() {
  var texts = getCartTextValues();
  var catBtn = document.querySelector('.category-btn.active');
  var catLabel = catBtn ? catBtn.textContent.trim() : '';
  var presetId = (typeof window.lcPresetId === 'string' && window.lcPresetId)
    ? window.lcPresetId
    : (lcPreset && lcPreset.id) ? lcPreset.id : 'default';
  var props = {};
  props[lcPropKey('first_name', 'Prénom')] = texts.prenom;
  props[lcPropKey('last_name', 'Nom de famille')] = texts.nom;
  props[lcPropKey('category', 'Catégorie')] = catLabel || getActiveCategoryId();
  props[lcPropKey('font', 'Police')] = selectedFont || 'Helvetica';
  if (selectedColor) {
    props[lcHiddenPropKey('color_hex', 'Code couleur')] = selectedColor;
    props[lcPropKey('color', 'Couleur')] = lcColorDisplayName(selectedColor, selectedModel);
  }
  if (lcPreset && lcPreset.name) props[lcHiddenPropKey('product_type', 'Type produit')] = lcPreset.name;
  props[lcPropKey('model', 'Modèle')] = lcModelDisplayName(selectedModel);
  props[lcHiddenPropKey('model_filename', 'Fichier JPG modèle')] = selectedModel;
  props[lcHiddenPropKey('alignment', 'Alignement')] = textAlign || 'left';
  props[lcHiddenPropKey('preset', 'Preset')] = presetId;
  var modelUrl = getSelectedModelUrl();
  if (modelUrl) props[lcHiddenPropKey('model_file', 'Fichier modèle')] = modelUrl;
  try {
    props[lcHiddenPropKey('placement', '_Placement')] = JSON.stringify(captureAllBoxState());
  } catch (e) { /* ignore */ }
  return props;
}

function getPreviewContext() {
  if (typeof context !== 'undefined' && context) return context;
  var canvas = document.getElementById('previewCanvas');
  return canvas ? canvas.getContext('2d') : null;
}

function toCanvasXY(clientX, clientY) {
  const rect = previewCanvas.getBoundingClientRect();
  const scaleX = previewCanvas.width / rect.width;
  const scaleY = previewCanvas.height / rect.height;
  const pixelScale = canvasPixelScale || 1;
  return {
    x: (clientX - rect.left) * scaleX / pixelScale,
    y: (clientY - rect.top) * scaleY / pixelScale
  };
}

function getPreviewPixelScale(nativeImageWidth) {
  if (!nativeImageWidth) return 1;
  if (!document.body.classList.contains('canvas-edit-mode') || !selectedEditBox) return 1;
  return Math.min(
    nativeImageWidth / PREVIEW_LOGICAL_WIDTH,
    EDIT_HIGH_RES_MAX_WIDTH / PREVIEW_LOGICAL_WIDTH
  );
}

function rememberModelNativeSize(width, height) {
  modelNativeWidth = width || 0;
  modelNativeHeight = height || 0;
}

function getSelectedModelUrl() {
  return resolveLcMediaUrl(lcRelativeMediaKey(imageBaseUrl, selectedModel));
}

function getModelCacheKey() {
  return getSelectedModelUrl();
}

function closeOrientedModelCache() {
  if (orientedModelCache.bitmap) {
    try { orientedModelCache.bitmap.close(); } catch (e) { /* ignore */ }
  }
  orientedModelCache = { key: '', width: 0, height: 0, bitmap: null, drawFallback: null };
}

function makeOrientedModelPage(cache) {
  return {
    width: cache.width,
    height: cache.height,
    draw: function (ctx, w, h) {
      if (cache.bitmap) {
        ctx.drawImage(cache.bitmap, 0, 0, w, h);
      } else if (cache.drawFallback) {
        cache.drawFallback(ctx, w, h);
      }
    }
  };
}

/** Dimensions affichées du modèle (orientation EXIF appliquée), partagées preview + PDF. */
function resolveOrientedModelSize(img) {
  var key = getModelCacheKey();
  if (orientedModelCache.key === key && orientedModelCache.width > 0 && orientedModelCache.height > 0) {
    return Promise.resolve(makeOrientedModelPage(orientedModelCache));
  }

  return new Promise(function (resolve) {
    function finish(page) {
      closeOrientedModelCache();
      orientedModelCache = {
        key: key,
        width: page.width,
        height: page.height,
        bitmap: null,
        drawFallback: page.draw
      };
      rememberModelNativeSize(page.width, page.height);
      resolve(page);
    }

    if (typeof createImageBitmap !== 'undefined') {
      createImageBitmap(img, { imageOrientation: 'from-image' })
        .then(function (bitmap) {
          closeOrientedModelCache();
          orientedModelCache = {
            key: key,
            width: bitmap.width,
            height: bitmap.height,
            bitmap: bitmap,
            drawFallback: null
          };
          rememberModelNativeSize(bitmap.width, bitmap.height);
          resolve(makeOrientedModelPage(orientedModelCache));
        })
        .catch(function () {
          finish(buildFallbackOrientedModelDraw(img));
        });
      return;
    }
    finish(buildFallbackOrientedModelDraw(img));
  });
}

function getOrientedModelPageForPdf() {
  var key = getModelCacheKey();
  if (orientedModelCache.key === key && orientedModelCache.width > 0 && orientedModelCache.height > 0) {
    return Promise.resolve(makeOrientedModelPage(orientedModelCache));
  }
  return lcLoadModelImage(key).then(function (pack) {
    return resolveOrientedModelSize(pack.img);
  });
}

function normalizePdfPageSize(pageW, pageH, previewW, previewH) {
  if (!pageW || !pageH || !previewW || !previewH) return { width: pageW, height: pageH };
  var previewAspect = previewW / previewH;
  var pageAspect = pageW / pageH;
  if (Math.abs(pageAspect - previewAspect) / previewAspect > 0.02) {
    return { width: pageW, height: Math.round(pageW / previewAspect) };
  }
  return { width: pageW, height: pageH };
}

function drawAllTextBoxes(ctx, text1, text2, font, color, updateFontSizes) {
  for (var boxIdx = 0; boxIdx < lcBoxCount; boxIdx++) {
    var presetBox = getPresetBox(boxIdx);
    var boxKey = 'box' + (boxIdx + 1);
    if (presetBox && presetBox.type === 'circle') {
      var scC = getBoxScale(boxKey);
      var zoneC = getCircleFitZone(boxKey, scC);
      var cg = getCircleMetrics(boxKey);
      var posC = getBoxXY(boxKey);
      var circleAlign = getCircleTextAlign(boxKey);
      var zoneLeftC = zoneLeftFromPivotX(posC.x, zoneC.width, circleAlign);
      var textTopC = posC.y;

      ctx.save();
      ctx.beginPath();
      ctx.arc(cg.cx, cg.cy, cg.radius, 0, Math.PI * 2);
      ctx.clip();
      ctx.fillStyle = color;

      var fitC = fitTextToFixedZone(ctx, text1, text2, font, initialFontSize * scC, zoneC.width, zoneC.height, 8);
      if (updateFontSizes) setBoxFontSize(boxKey, fitC.fontSize);

      var padTopC = Math.max(0, (zoneC.height - fitC.totalH) * 0.5);
      ctx.textAlign = canvasTextAlignFromChoice(circleAlign);
      var xAlignC = zoneXFromAlign(zoneLeftC, zoneC.width, circleAlign);
      var base1C = textTopC + padTopC + fitC.a1;
      fillTextTwoLinesFromFit(ctx, fitC, font, xAlignC, base1C, text1, text2);
      ctx.restore();
      continue;
    }
    if (!presetBox) continue;

    var pos = getBoxXY(boxKey);
    var sc = getBoxScale(boxKey);
    var boxAlign = getBoxTextAlign(boxKey);
    var w = getBoxMaxWidth(boxKey) * sc;
    var h = getBoxMaxHeight(boxKey) * sc;

    ctx.save();
    var zone = getFreeBoxZoneRect(boxKey, pos, sc, boxAlign, ctx, font);
    var fit = fitTextToFixedZone(ctx, text1, text2, font, initialFontSize * sc, w, h);

    ctx.beginPath();
    ctx.rect(zone.left, zone.top, w, h);
    ctx.clip();
    ctx.fillStyle = color;

    if (updateFontSizes) setBoxFontSize(boxKey, fit.fontSize);

    var xAlign;
    if (boxAlign === 'center') {
      ctx.textAlign = 'center';
      xAlign = zone.left + w / 2;
    } else if (boxAlign === 'right') {
      ctx.textAlign = 'right';
      xAlign = zone.left + w;
    } else {
      ctx.textAlign = 'left';
      xAlign = zone.left;
    }

    var baseline1 = zone.top + FREE_BOX_TEXT_INSET + fit.a1;
    fillTextTwoLinesFromFit(ctx, fit, font, xAlign, baseline1, text1, text2);
    ctx.restore();
  }
}

function updateAllBoxBBoxes(ctx, text1, text2, font) {
  var editTight = isCanvasEditUnlocked();
  for (var boxIdx = 0; boxIdx < lcBoxCount; boxIdx++) {
    var presetBox = getPresetBox(boxIdx);
    var boxKey = 'box' + (boxIdx + 1);
    if (presetBox && presetBox.type === 'circle') {
      var scC = getBoxScale(boxKey);
      var zoneC = getCircleFitZone(boxKey, scC);
      var posC = getBoxXY(boxKey);
      var alignC = getCircleTextAlign(boxKey);
      var fitC = fitTextToFixedZone(ctx, text1, text2, font, initialFontSize * scC, zoneC.width, zoneC.height, 8);
      var zoneLeftC = zoneLeftFromPivotX(posC.x, zoneC.width, alignC);
      if (editTight) {
        var padTopC = Math.max(0, (zoneC.height - fitC.totalH) * 0.5);
        var textWC = Math.max(fitC.w1, fitC.w2);
        setBoxBBox(boxKey, {
          x: textBlockLeftInZone(zoneLeftC, zoneC.width, textWC, alignC),
          y: posC.y + padTopC,
          width: textWC,
          height: fitC.totalH,
          pivotX: posC.x,
          pivotY: posC.y
        });
      } else {
        setBoxBBox(boxKey, {
          x: zoneLeftC,
          y: posC.y,
          width: zoneC.width,
          height: zoneC.height
        });
      }
      continue;
    }
    if (!presetBox) continue;
    var pos = getBoxXY(boxKey);
    var sc = getBoxScale(boxKey);
    var align = getBoxTextAlign(boxKey);
    var zone = getFreeBoxZoneRect(boxKey, pos, sc, align, ctx, font);
    if (editTight) {
      var w = getBoxMaxWidth(boxKey) * sc;
      var h = getBoxMaxHeight(boxKey) * sc;
      var fit = fitTextToFixedZone(ctx, text1, text2, font, initialFontSize * sc, w, h);
      var textW = Math.max(fit.w1, fit.w2);
      setBoxBBox(boxKey, {
        x: textBlockLeftInZone(zone.left, zone.width, textW, align),
        y: zone.top + FREE_BOX_TEXT_INSET,
        width: textW,
        height: fit.totalH,
        pivotX: zone.pivotX,
        pivotY: zone.pivotY
      });
    } else {
      setBoxBBox(boxKey, {
        x: zone.left,
        y: zone.top,
        width: zone.width,
        height: zone.height,
        pivotX: zone.pivotX,
        pivotY: zone.pivotY
      });
    }
  }
}

var PDF_PX_TO_PT = 72 / 96;
/** Bord long minimal du fond raster PDF (impression). */
var PDF_MIN_LONG_EDGE_PX = 2400;

function getPdfPageDimensions(orientedPage) {
  var previewAspect = previewLogicalWidth / previewLogicalHeight;
  var pageW = orientedPage && orientedPage.width ? orientedPage.width : modelNativeWidth;
  var pageH = orientedPage && orientedPage.height ? orientedPage.height : modelNativeHeight;
  if (!pageW || !pageH) {
    pageW = Math.round(PREVIEW_LOGICAL_WIDTH * 4);
    pageH = Math.round(pageW / previewAspect);
  }
  if (previewAspect >= 1 && pageW < pageH) {
    var swap = pageW;
    pageW = pageH;
    pageH = swap;
  } else if (previewAspect < 1 && pageH < pageW) {
    var swap2 = pageW;
    pageW = pageH;
    pageH = swap2;
  }
  var targetH = Math.round(pageW / previewAspect);
  if (Math.abs(pageH - targetH) / Math.max(targetH, 1) <= 0.03) {
    pageH = targetH;
  }
  var longEdge = Math.max(pageW, pageH);
  if (longEdge < PDF_MIN_LONG_EDGE_PX) {
    var scaleUp = PDF_MIN_LONG_EDGE_PX / longEdge;
    pageW = Math.round(pageW * scaleUp);
    pageH = Math.round(pageH * scaleUp);
  }
  return { width: Math.round(pageW), height: Math.round(pageH) };
}

function loadOrientedPageForPdfExport() {
  return lcLoadImageViaBlob(getSelectedModelUrl()).then(function (modelPack) {
    return resolveOrientedModelSize(modelPack.img).then(function (page) {
      return { page: page, revoke: modelPack.revoke };
    });
  }).catch(function () {
    return getOrientedModelPageForPdf().then(function (page) {
      return { page: page, revoke: null };
    });
  });
}

/** Fond modèle pleine résolution (bitmap orienté du cache preview). */
function createPdfModelBackgroundCanvas(page, pageW, pageH) {
  var canvas = document.createElement('canvas');
  canvas.width = pageW;
  canvas.height = pageH;
  var ctx = canvas.getContext('2d');
  ctx.imageSmoothingEnabled = true;
  if (ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = 'high';
  page.draw(ctx, pageW, pageH);
  return canvas;
}

function parsePdfTextColor() {
  var r = 0, g = 0, b = 0;
  if (selectedColor && selectedColor.match(/^#([0-9a-fA-F]{6})$/)) {
    var hex = selectedColor.match(/^#([0-9a-fA-F]{6})$/)[1];
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else if (selectedColor && selectedColor.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/)) {
    var m = selectedColor.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/);
    r = parseInt(m[1], 10);
    g = parseInt(m[2], 10);
    b = parseInt(m[3], 10);
  }
  return { r: r, g: g, b: b };
}

function setupPdfFont(pdf, fontBase64OrNull) {
  var customFonts = { 'Comic': 'comic.ttf', 'MV Boli': 'mvboli.ttf', 'Inkfree': 'Inkfree.ttf' };
  if (fontBase64OrNull && customFonts[selectedFont]) {
    try {
      pdf.addFileToVFS(customFonts[selectedFont], fontBase64OrNull);
      pdf.addFont(customFonts[selectedFont], 'CustomFont', 'normal');
      return 'CustomFont';
    } catch (e) { /* fallback helvetica */ }
  }
  return 'helvetica';
}

function createJsPdfDocument(pagePxW, pagePxH) {
  var JsPDF = window.jspdf && window.jspdf.jsPDF;
  if (!JsPDF) throw new Error('jsPDF unavailable');
  var pagePtW = pagePxW * PDF_PX_TO_PT;
  var pagePtH = pagePxH * PDF_PX_TO_PT;
  var pdf = new JsPDF({
    unit: 'pt',
    format: [pagePtW, pagePtH],
    compress: false
  });
  return {
    pdf: pdf,
    pagePxW: pagePxW,
    pagePxH: pagePxH,
    pagePtW: pdf.internal.pageSize.getWidth(),
    pagePtH: pdf.internal.pageSize.getHeight()
  };
}

function addVectorTextToPdf(doc, text1, text2) {
  var pdf = doc.pdf;
  var previewW = previewLogicalWidth;
  var previewH = previewLogicalHeight;
  var scaleX = doc.pagePtW / previewW;
  var scaleY = doc.pagePtH / previewH;
  var measureFont = selectedFont || 'Helvetica';

  for (var bi = 1; bi <= lcBoxCount; bi++) {
    var pdfBoxKey = 'box' + bi;
    if (isCircleBoxKey(pdfBoxKey)) {
      var sc3 = getBoxScale(pdfBoxKey);
      var zone = getCircleFitZone(pdfBoxKey, sc3);
      var pos = getBoxXY(pdfBoxKey);
      var circleAlign = getCircleTextAlign(pdfBoxKey);
      var pdfCircleAlign = canvasTextAlignFromChoice(circleAlign);
      var ctxCirclePdf = getPreviewContext() || getMeasureContext();
      var fitCirclePdf = fitTextToFixedZone(
        ctxCirclePdf,
        text1,
        text2,
        measureFont,
        initialFontSize * sc3,
        zone.width,
        zone.height,
        8
      );
      var circleZoneW = zone.width * scaleX;
      var circleZoneLeft = zoneLeftFromPivotX(pos.x * scaleX, circleZoneW, circleAlign);
      var xPosPdfCircle = zoneXFromAlign(circleZoneLeft, circleZoneW, circleAlign);
      var circlePivotY = pos.y * scaleY;
      var padTopPdf = Math.max(0, (zone.height - fitCirclePdf.totalH) * 0.5);
      var base1_3 = (pos.y + padTopPdf + fitCirclePdf.a1) * scaleY;
      var fs1c = fitCirclePdf.fontSize1 != null ? fitCirclePdf.fontSize1 : fitCirclePdf.fontSize;
      var fs2c = fitCirclePdf.fontSize2 != null ? fitCirclePdf.fontSize2 : fitCirclePdf.fontSize;
      if (text1) {
        pdf.setFontSize(fs1c * scaleY);
        pdf.text(text1, xPosPdfCircle, base1_3, { align: pdfCircleAlign, baseline: 'alphabetic' });
      }
      if (text2) {
        var base2_3 = base1_3 + (fitCirclePdf.d1 + fitCirclePdf.lineSpacing + fitCirclePdf.a2) * scaleY;
        pdf.setFontSize(fs2c * scaleY);
        pdf.text(text2, xPosPdfCircle, base2_3, { align: pdfCircleAlign, baseline: 'alphabetic' });
      }
      continue;
    }
    if (!isFreePresetBox(bi - 1)) continue;

    var sc = getBoxScale(pdfBoxKey);
    var posFb = getBoxXY(pdfBoxKey);
    var zoneW = getBoxMaxWidth(pdfBoxKey) * sc * scaleX;
    var boxAlignPdf = getBoxTextAlign(pdfBoxKey);
    var ctxPdf = getPreviewContext() || getMeasureContext();
    var zoneWLogical = getBoxMaxWidth(pdfBoxKey) * sc;
    var zoneHLogical = getBoxMaxHeight(pdfBoxKey) * sc;
    var fitPdf = fitTextToFixedZone(
      ctxPdf,
      text1,
      text2,
      measureFont,
      initialFontSize * sc,
      zoneWLogical,
      zoneHLogical
    );
    var zone = getFreeBoxZoneRect(
      pdfBoxKey,
      { x: posFb.x, y: posFb.y },
      sc,
      boxAlignPdf,
      ctxPdf,
      measureFont
    );
    var zoneLeft = zone.left * scaleX;
    var xPosPdf;
    if (boxAlignPdf === 'center') {
      xPosPdf = zoneLeft + zoneW / 2;
    } else if (boxAlignPdf === 'right') {
      xPosPdf = zoneLeft + zoneW;
    } else {
      xPosPdf = zoneLeft;
    }
    var base1 = (zone.top + FREE_BOX_TEXT_INSET + fitPdf.a1) * scaleY;
    var fs1p = fitPdf.fontSize1 != null ? fitPdf.fontSize1 : fitPdf.fontSize;
    var fs2p = fitPdf.fontSize2 != null ? fitPdf.fontSize2 : fitPdf.fontSize;
    if (text1) {
      pdf.setFontSize(fs1p * scaleY);
      pdf.text(text1, xPosPdf, base1, { align: boxAlignPdf, baseline: 'alphabetic' });
    }
    if (text2) {
      var base2 = base1 + (fitPdf.d1 + fitPdf.lineSpacing + fitPdf.a2) * scaleY;
      pdf.setFontSize(fs2p * scaleY);
      pdf.text(text2, xPosPdf, base2, { align: boxAlignPdf, baseline: 'alphabetic' });
    }
  }
}

function lcGetPdfCustomFontPaths() {
  var base = (typeof window.lcFontsBaseUrl === 'string' && window.lcFontsBaseUrl)
    ? window.lcFontsBaseUrl
    : './fonts/';
  if (base.charAt(base.length - 1) !== '/') base += '/';
  return {
    'Comic': base + 'comic.ttf',
    'MV Boli': base + 'mvboli.ttf',
    'Inkfree': base + 'Inkfree.ttf'
  };
}

function lcLoadFontBase64ForPdf(fontPath) {
  return fetch(fontPath)
    .then(function (r) {
      if (!r.ok) throw new Error('font fetch');
      return r.blob();
    })
    .then(function (blob) {
      return new Promise(function (resolve, reject) {
        var fr = new FileReader();
        fr.onload = function () { resolve(fr.result.split(',')[1]); };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
      });
    });
}

function lcUint8ArrayToBase64(bytes) {
  var chunk = 0x8000;
  var parts = [];
  for (var i = 0; i < bytes.length; i += chunk) {
    parts.push(String.fromCharCode.apply(null, bytes.subarray(i, i + chunk)));
  }
  return btoa(parts.join(''));
}

function renderVectorPdfJsPdf(fontBase64OrNull) {
  var previewTexts = getPreviewTexts();
  var text1 = previewTexts.text1;
  var text2 = previewTexts.text2;

  return loadOrientedPageForPdfExport().then(function (pack) {
    var page = pack.page;
    var dims = getPdfPageDimensions(page);
    var pagePxW = dims.width;
    var pagePxH = dims.height;
    var bgCanvas = createPdfModelBackgroundCanvas(page, pagePxW, pagePxH);
    var doc = createJsPdfDocument(pagePxW, pagePxH);
    var pdf = doc.pdf;
    var pngData = bgCanvas.toDataURL('image/png');
    pdf.addImage(
      pngData,
      'PNG',
      0,
      0,
      doc.pagePtW,
      doc.pagePtH,
      undefined,
      'SLOW'
    );

    var fontId = setupPdfFont(pdf, fontBase64OrNull);
    pdf.setFont(fontId, 'normal');
    var rgb = parsePdfTextColor();
    pdf.setTextColor(rgb.r, rgb.g, rgb.b);
    addVectorTextToPdf(doc, text1, text2);
    return { pdf: pdf, pack: pack };
  });
}

/** Même PDF que le bouton Télécharger — data URI application/pdf. */
function buildVectorPdfDataUri(fontBase64OrNull) {
  return renderVectorPdfJsPdf(fontBase64OrNull).then(function (result) {
    var out = result.pdf.output('datauristring');
    if (result.pack.revoke) URL.revokeObjectURL(result.pack.revoke);
    return out;
  });
}

/** Bytes bruts (base64) pour upload worker — identique au téléchargement local. */
function buildVectorPdfBase64(fontBase64OrNull) {
  return renderVectorPdfJsPdf(fontBase64OrNull).then(function (result) {
    var buf = result.pdf.output('arraybuffer');
    var b64 = lcUint8ArrayToBase64(new Uint8Array(buf));
    if (result.pack.revoke) URL.revokeObjectURL(result.pack.revoke);
    return b64;
  });
}

function generateVectorPdf(fontBase64OrNull) {
  return buildVectorPdfDataUri(fontBase64OrNull).then(function (dataUri) {
    var link = document.createElement('a');
    link.href = dataUri;
    link.download = 'customization-preview.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });
}

function lcGenerateVectorPdfForUpload() {
  var waitFn = window.lcWhenPreviewReadyForExport;
  var wait = (typeof waitFn === 'function')
    ? waitFn({ timeoutMs: 20000, refresh: false })
    : Promise.resolve(true);
  return wait.then(function () {
    if (!previewReadyForPdf || !previewLogicalWidth || !previewLogicalHeight) {
      return '';
    }
    var fontPath = lcGetPdfCustomFontPaths()[selectedFont];
    return (fontPath ? lcLoadFontBase64ForPdf(fontPath) : Promise.resolve(null))
      .catch(function () { return null; })
      .then(function (fontBase64) {
        return buildVectorPdfBase64(fontBase64);
      })
      .catch(function () { return ''; });
  });
}

function buildFallbackOrientedModelDraw(img) {
  var nw = img.naturalWidth || img.width || previewLogicalWidth;
  var nh = img.naturalHeight || img.height || previewLogicalHeight;
  var previewLandscape = previewLogicalWidth >= previewLogicalHeight;
  var naturalLandscape = nw >= nh;
  var needSwap = previewLandscape !== naturalLandscape;
  var pageW = needSwap ? nh : nw;
  var pageH = needSwap ? nw : nh;

  if (needSwap) {
    return {
      width: pageW,
      height: pageH,
      draw: function (ctx, w, h) {
        ctx.save();
        ctx.translate(0, h);
        ctx.rotate(-Math.PI / 2);
        ctx.drawImage(img, 0, 0, nw, nh);
        ctx.restore();
      }
    };
  }
  return {
    width: pageW,
    height: pageH,
    draw: function (ctx, w, h) {
      ctx.drawImage(img, 0, 0, w, h);
    }
  };
}

function renderPreviewWithOrientedModel(modelImage, drawFn) {
  var gen = ++previewLoadGen;
  previewReadyForPdf = false;
  resolveOrientedModelSize(modelImage).then(function (page) {
    if (gen !== previewLoadGen) return;
    var aspectRatio = page.width / page.height;
    var logicalW = PREVIEW_LOGICAL_WIDTH;
    var logicalH = PREVIEW_LOGICAL_WIDTH / aspectRatio;
    canvasPixelScale = getPreviewPixelScale(page.width);
    previewLogicalWidth = logicalW;
    previewLogicalHeight = logicalH;
    previewReadyForPdf = true;
    previewCanvas.width = Math.round(logicalW * canvasPixelScale);
    previewCanvas.height = Math.round(logicalH * canvasPixelScale);
    context.setTransform(canvasPixelScale, 0, 0, canvasPixelScale, 0, 0);
    context.imageSmoothingEnabled = true;
    if (context.imageSmoothingQuality) context.imageSmoothingQuality = 'high';
    context.clearRect(0, 0, logicalW, logicalH);
    page.draw(context, logicalW, logicalH);
    drawFn(logicalW, logicalH);
  });
}


function getMinScaleFloorForBox(boxKey) {
  if (isCircleBoxKey(boxKey)) return 0.2;
  return 0.25;
}

function getZoneSizeForScale(boxKey, sc) {
  if (isCircleBoxKey(boxKey)) {
    var zone = getCircleFitZone(boxKey, sc);
    return { w: zone.width, h: zone.height, minFont: 8 };
  }
  return {
    w: getBoxMaxWidth(boxKey) * sc,
    h: getBoxMaxHeight(boxKey) * sc,
    minFont: 10
  };
}

function textFitsInZoneAtScale(boxKey, sc, text1, text2, font) {
  var sizes = getZoneSizeForScale(boxKey, sc);
  var ctx = getPreviewContext() || getMeasureContext();
  var fit = fitTextToFixedZone(
    ctx, text1, text2, font, initialFontSize * sc, sizes.w, sizes.h, sizes.minFont
  );
  return zoneTextFitsLayout(fit, sizes.w, sizes.h, 2);
}

function getMinScaleFactorForBox(boxKey) {
  var floor = getMinScaleFloorForBox(boxKey);
  var previewTexts = getPreviewTexts();
  var text1 = previewTexts.text1;
  var text2 = previewTexts.text2;
  var font = selectedFont || 'Helvetica';
  var maxSc = Math.min(1, getMaxScaleForBox(boxKey));

  if (!textFitsInZoneAtScale(boxKey, maxSc, text1, text2, font)) {
    return maxSc;
  }
  if (textFitsInZoneAtScale(boxKey, floor, text1, text2, font)) {
    return floor;
  }

  var lo = floor;
  var hi = maxSc;
  var result = maxSc;
  for (var i = 0; i < 24; i++) {
    var mid = (lo + hi) / 2;
    if (textFitsInZoneAtScale(boxKey, mid, text1, text2, font)) {
      result = mid;
      hi = mid;
    } else {
      lo = mid;
    }
  }
  return result;
}

function clampBoxPositionToSafeZone(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var preset = getPresetBox(idx);
  if (!preset) return;
  var pos = getBoxXY(boxKey);
  var sc = getBoxScale(boxKey);
  if (preset.type === 'circle') {
    var cCircle = clampCircleTextPos(boxKey, pos.x, pos.y);
    setBoxXY(boxKey, cCircle.x, cCircle.y);
    return;
  }
  var cFree = clampFreeBoxPosByKey(boxKey, pos.x, pos.y, sc);
  setBoxXY(boxKey, cFree.x, cFree.y);
}

function clampBoxScaleToTextFit(boxKey) {
  var minSc = getMinScaleFactorForBox(boxKey);
  var sc = getBoxScale(boxKey);
  if (sc < minSc) setBoxScale(boxKey, minSc);
  clampBoxPositionToSafeZone(boxKey);
}

function getMeasureContext() {
  if (!getMeasureContext._ctx) {
    var c = document.createElement('canvas');
    c.width = 1;
    c.height = 1;
    getMeasureContext._ctx = c.getContext('2d');
  }
  return getMeasureContext._ctx;
}

function getPresetDefaultScale(boxKey) {
  var idx = parseInt(String(boxKey).slice(3), 10) - 1;
  var b = getPresetBox(idx);
  if (b && b.scale != null) return b.scale;
  if (boxKey === 'box2') return 0.4;
  if (boxKey === 'box3') return 0.5;
  return 1;
}

function getMaxScaleForBox(boxKey) {
  var marginMax = 1;
  if (isCircleBoxKey(boxKey)) {
    marginMax = (2 * getCircleMetrics(boxKey).radius * 0.95) / getBoxMaxWidth(boxKey);
  } else {
    var m = getBoxMargins(boxKey);
    var availW = previewLogicalWidth - m.left - m.right;
    var availHt = previewLogicalHeight - m.top - m.bottom;
    if (availW > 0 && availHt > 0) {
      marginMax = Math.min(availW / getBoxMaxWidth(boxKey), availHt / getBoxMaxHeight(boxKey));
    }
  }
  return Math.max(marginMax, getPresetDefaultScale(boxKey));
}

function clampScale(newScale, minSc, maxSc, prevScale) {
  if (maxSc <= 0) return prevScale != null ? prevScale : minSc;
  if (minSc > maxSc) minSc = Math.max(0.1, maxSc * 0.95);
  var prev = prevScale != null ? prevScale : newScale;
  if (prev > maxSc) {
    if (newScale < prev) return Math.max(minSc, Math.max(maxSc, newScale));
    if (newScale > prev) return prev;
    return prev;
  }
  return Math.max(minSc, Math.min(newScale, maxSc));
}



function isPreviewLoadStillRelevant(loadGen, modelUrl) {
  if (loadGen === previewImageLoadGen) return true;
  return modelUrl === getSelectedModelUrl();
}

function paintPreviewFromModelImage(modelImage, previewTexts, font, color, paintLoadGen) {
  var inputText1 = previewTexts.text1;
  var inputText2 = previewTexts.text2;
  renderPreviewWithOrientedModel(modelImage, function (logicalW, logicalH) {
    if (isUniCategoryMode() && needInitUniCategory) {
      initAllFreeBoxesUniCenter(logicalW, logicalH, initialFontSize);
      initAllCircleBoxesCenter();
      needInitUniCategory = false;
      uniCategoryState = captureAllBoxState();
    }

    for (var clampIdx = 0; clampIdx < lcBoxCount; clampIdx++) {
      clampBoxScaleToTextFit('box' + (clampIdx + 1));
    }
    drawAllTextBoxes(context, inputText1, inputText2, font, color, true);
    updateAllBoxBBoxes(context, inputText1, inputText2, font);
    if (isCanvasEditUnlocked()) drawEditOverlays(context);
    if (selectedEditBox) requestAnimationFrame(updateEditViewport);
    if (paintLoadGen != null && paintLoadGen === previewImageLoadGen) {
      previewPaintDoneLoadGen = paintLoadGen;
    }
  });
}

function updatePreview(retryCount) {
  retryCount = retryCount || 0;
  var loadGen = ++previewImageLoadGen;
  const previewTexts = getPreviewTexts();
  const font = selectedFont;
  const color = selectedColor;

  var modelUrl = getSelectedModelUrl();
  lcLoadModelImage(modelUrl).then(function (pack) {
    if (!isPreviewLoadStillRelevant(loadGen, modelUrl)) return;
    window.lcModelImageCorsOk = pack.corsOk;
    var modelImage = pack.img;
    function drawWhenReady() {
      if (!isPreviewLoadStillRelevant(loadGen, modelUrl)) return;
      paintPreviewFromModelImage(modelImage, previewTexts, font, color, loadGen);
    }
    if (typeof modelImage.decode === 'function') {
      modelImage.decode().then(drawWhenReady).catch(drawWhenReady);
    } else {
      drawWhenReady();
    }
  }).catch(function () {
    if (!isPreviewLoadStillRelevant(loadGen, modelUrl)) return;
    if (retryCount < 3) {
      setTimeout(function () { updatePreview(retryCount + 1); }, 120 * (retryCount + 1));
    }
  });
}

var lcPreviewLayoutRefreshTimer = null;
function lcSchedulePreviewLayoutRefresh() {
  clearTimeout(lcPreviewLayoutRefreshTimer);
  lcPreviewLayoutRefreshTimer = setTimeout(function () {
    lcPreviewLayoutRefreshTimer = null;
    if (!document.getElementById('previewCanvas')) return;
    updatePreview();
  }, 80);
}

function lcBindPreviewLayoutRefresh() {
  window.addEventListener('resize', lcSchedulePreviewLayoutRefresh);
  window.addEventListener('load', lcSchedulePreviewLayoutRefresh);
  var viewport = document.querySelector('.preview-canvas-viewport');
  if (viewport && typeof ResizeObserver !== 'undefined') {
    var lastW = 0;
    var lastH = 0;
    var ro = new ResizeObserver(function (entries) {
      var entry = entries && entries[0];
      if (!entry) return;
      var w = Math.round(entry.contentRect.width);
      var h = Math.round(entry.contentRect.height);
      if (w === lastW && h === lastH) return;
      lastW = w;
      lastH = h;
      if (w < 2 || h < 2) return;
      lcSchedulePreviewLayoutRefresh();
    });
    ro.observe(viewport);
  }
}

function lcEnsureInitialPreview() {
  [0, 150, 500, 1200].forEach(function (delay) {
    setTimeout(function () {
      if (!previewReadyForPdf) updatePreview();
    }, delay);
  });
}

/** Résout quand le canvas preview est peint (évite export vide sans DevTools/resize). */
function lcWhenPreviewReadyForExport(options) {
  options = options || {};
  var timeoutMs = options.timeoutMs != null ? options.timeoutMs : 10000;
  var deadline = Date.now() + timeoutMs;
  var canvas = previewCanvas || document.getElementById('previewCanvas');
  var alreadyPainted = previewPaintDoneLoadGen === previewImageLoadGen &&
    previewReadyForPdf &&
    canvas && canvas.width > 1 && canvas.height > 1;
  if (!alreadyPainted) {
    updatePreview();
  }
  return new Promise(function (resolve) {
    function tick() {
      var c = previewCanvas || document.getElementById('previewCanvas');
      var painted = previewPaintDoneLoadGen === previewImageLoadGen && previewReadyForPdf;
      var sized = c && c.width > 1 && c.height > 1;
      if (painted && sized) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { resolve(true); });
        });
        return;
      }
      if (Date.now() >= deadline) {
        resolve(true);
        return;
      }
      setTimeout(tick, 50);
    }
    tick();
  });
}










    // Default model / color (ne pas écraser si le preset a déjà défini selectedModel via ses catégories)
    if (presetCategoryIds.length === 0) {
        selectedModel = 'kit_NEW_cupcake_2024.jpg';
        window.lcSelectedModel = selectedModel;
    }
    const availableColors = getModelColors(selectedModel);
    if (availableColors.length > 0) {
        selectedColor = availableColors[0];
    }
    selectedFont = 'Helvetica';

    syncFontButtonState(selectedFont);
    updateColorSwatches(selectedModel);
    setTimeout(function () { updateColorSwatches(selectedModel); }, 0);
    setTimeout(function () { updateColorSwatches(selectedModel); }, 300);


	



// Prevent the text box from resetting its position when typing
bindLabelTextField(document.getElementById('customText1'));
bindLabelTextField(document.getElementById('customText2'));








    // Event listeners for user inputs (bindLabelTextField gère input + preview)
    bindLabelTextField(document.getElementById('customText1'));
    bindLabelTextField(document.getElementById('customText2'));
	
	


/*
    // Load the custom font into jsPDF
    fetch(fontUrl)
        .then(response => response.arrayBuffer())
        .then(data => {
            // Convert the font to base64
            const fontBase64 = btoa(String.fromCharCode(...new Uint8Array(data)));

            // Add the custom font to jsPDF
            jsPDF.API.addFileToVFS('mvboli.ttf', fontBase64);
            jsPDF.API.addFont('mvboli.ttf', 'MV Boli', 'normal');

            // Set the default font for the document
            selectedFont = 'MV Boli';
            console.log('Custom Font Loaded and Applied:', selectedFont);
        })
        .catch(error => {
            console.error('Error loading the custom font:', error);
            // Fallback to a default font if loading fails
            selectedFont = 'Helvetica';
        });
*/

    // Initialize with the default selected model and color options
    updatePreview();
    lcEnsureInitialPreview();
    lcBindPreviewLayoutRefresh();

    window.addEventListener('pageshow', function (ev) {
      if (ev.persisted || !previewReadyForPdf) updatePreview();
    });







function getMinScaleFactor() {
  const previewTexts = getPreviewTexts();
  const text1 = previewTexts.text1;
  const text2 = previewTexts.text2;
  const totalLength = text1.length + text2.length;
  
  // Base minimum scale factor
  const baseMin = 0.7; // if text is very short, allow scaling down to 50%
  
  // If the text is longer than a threshold, increase the minimum scale.
  // For example, for every 10 characters above 20, add 0.1.
  const threshold = 20;
  const incrementPer10 = 0.1;
  const extra = Math.max(0, totalLength - threshold);
  let minScale = baseMin + (extra / 10) * incrementPer10;
  
  // Cap the min scale at 1.0 (i.e. do not allow scaling below original size)
  return Math.min(minScale, 1.0);
}



let firstTouchId = null;      // id du 1er doigt
let firstTouchOn = null;      // 'box1' | 'box2' | 'box3' | null

// Snapshot de pinch pris à l’instant où le 2e doigt arrive
let pinchStart = null;        // { target, pivotX, pivotY, startScale, startX, startY, minScale, maxScale, initDist }


// Pivot du pinch (toujours le 1er doigt)
let pinchPivotX = 0, pinchPivotY = 0;

function isPointInBBox(x, y, bbox) {
  return x >= bbox.x && x <= bbox.x + bbox.width &&
         y >= bbox.y && y <= bbox.y + bbox.height;
}

function clearLongPress() {
  if (longPressTimeout) {
    clearTimeout(longPressTimeout);
    longPressTimeout = null;
  }
  pendingDragTarget = null;
}

function isCanvasEditUnlocked() {
  return document.body.classList.contains('canvas-edit-mode');
}

function resetCanvasInteraction() {
  clearLongPress();
  isDragging = false;
  isPinching = false;
  activeDrag = null;
  firstTouchId = null;
  firstTouchOn = null;
  pinchStart = null;
  stopDocumentDrag();
}

function getConstraintBounds(boxKey) {
  var w = previewLogicalWidth;
  var h = previewLogicalHeight;
  if (!w || !h) return null;
  if (isCircleBoxKey(boxKey)) {
    return { x: circleCenterX - circleRadius, y: circleCenterY - circleRadius, width: circleRadius * 2, height: circleRadius * 2 };
  }
  var m = getBoxMargins(boxKey);
  return { x: m.left, y: m.top, width: w - m.left - m.right, height: h - m.top - m.bottom };
}

function hitTestEditBox(x, y) {
  for (var hi = lcBoxCount - 1; hi >= 0; hi--) {
    var hKey = 'box' + (hi + 1);
    if (isPointInBBox(x, y, getBoxBBox(hKey))) return hKey;
  }
  return null;
}

function getPreviewCanvasElements() {
  var viewport = document.querySelector('.preview-canvas-viewport');
  var wrap = viewport
    ? viewport.querySelector('.preview-canvas-wrap')
    : document.querySelector('.preview-canvas-wrap');
  return { viewport: viewport, wrap: wrap };
}

function getEditZoomBounds(boxKey) {
  var margin = getConstraintBounds(boxKey);
  if (!margin) return null;
  var bbox = getBoxBBox(boxKey);
  if (!bbox || !bbox.width) return margin;
  var x1 = Math.min(margin.x, bbox.x);
  var y1 = Math.min(margin.y, bbox.y);
  var x2 = Math.max(margin.x + margin.width, bbox.x + bbox.width);
  var y2 = Math.max(margin.y + margin.height, bbox.y + bbox.height);
  return { x: x1, y: y1, width: x2 - x1, height: y2 - y1 };
}

function updateEditViewport() {
  var els = getPreviewCanvasElements();
  var viewport = els.viewport;
  var wrap = els.wrap;
  try {
    if (!wrap || !previewLogicalWidth) return;
    if (!selectedEditBox || !isCanvasEditUnlocked()) {
      wrap.style.transform = '';
      if (viewport) viewport.style.height = '';
      return;
    }
    var bounds = getEditZoomBounds(selectedEditBox);
    if (!bounds || bounds.width <= 0 || bounds.height <= 0) return;

    var W = previewLogicalWidth;
    var H = previewLogicalHeight;
    var displayW = (viewport || wrap).clientWidth;
    var displayH = displayW * (H / W);
    if (viewport) viewport.style.height = displayH + 'px';
    var dbx = bounds.x / W * displayW;
    var dby = bounds.y / H * displayH;
    var dbw = bounds.width / W * displayW;
    var dbh = bounds.height / H * displayH;
    var pad = 0.08;
    var scale = Math.min(
      (displayW * (1 - 2 * pad)) / dbw,
      (displayH * (1 - 2 * pad)) / dbh,
      EDIT_MAX_ZOOM
    );
    scale = Math.max(1, scale);
    var cx = dbx + dbw / 2;
    var cy = dby + dbh / 2;
    var tx = displayW / 2 - cx * scale;
    var ty = displayH / 2 - cy * scale;
    wrap.style.transformOrigin = '0 0';
    wrap.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
  } finally {
    updateCanvasZoomClose();
  }
}

function updateCanvasZoomClose() {
  var btn = document.getElementById('canvasZoomClose');
  if (!btn) return;
  var show = !!(selectedEditBox && isCanvasEditUnlocked());
  btn.hidden = !show;
  btn.setAttribute('aria-hidden', show ? 'false' : 'true');
}

function clearEditSelection() {
  if (!selectedEditBox) return;
  selectedEditBox = null;
  document.body.classList.remove('canvas-edit-box-selected');
  var els = getPreviewCanvasElements();
  if (els.wrap) els.wrap.style.transform = '';
  if (els.viewport) els.viewport.style.height = '';
  updateCanvasZoomClose();
  resetCanvasEditCoachOnDeselect();
  updatePreview();
}

function selectEditBox(boxKey) {
  selectedEditBox = boxKey;
  lastEditBoxSelectAt = Date.now();
  document.body.classList.add('canvas-edit-box-selected');
  advanceCanvasEditCoach();
  updateCanvasZoomClose();
  updatePreview();
}

function drawEditOverlays(ctx) {
  var items = [];
  for (var oi = 0; oi < lcBoxCount; oi++) {
    items.push({ key: 'box' + (oi + 1), bbox: getBoxBBox('box' + (oi + 1)) });
  }

  items.forEach(function (item) {
    var sel = selectedEditBox === item.key;
    var b = item.bbox;
    if (!b.width && !b.height) return;
    ctx.save();
    ctx.strokeStyle = sel ? '#FC9221' : 'rgba(104, 177, 66, 0.65)';
    ctx.lineWidth = sel ? 3 : 1.5;
    ctx.setLineDash(sel ? [] : [6, 4]);
    ctx.strokeRect(b.x, b.y, b.width, b.height);
    if (sel) {
      ctx.fillStyle = 'rgba(252, 146, 33, 0.12)';
      ctx.fillRect(b.x, b.y, b.width, b.height);
    }
    ctx.restore();
  });

  if (selectedEditBox) {
    var c = getConstraintBounds(selectedEditBox);
    if (c) {
      ctx.save();
      ctx.strokeStyle = 'rgba(252, 146, 33, 0.4)';
      ctx.lineWidth = 2;
      ctx.setLineDash([8, 6]);
      if (isCircleBoxKey(selectedEditBox)) {
        ctx.beginPath();
        ctx.arc(circleCenterX, circleCenterY, circleRadius, 0, Math.PI * 2);
        ctx.stroke();
      } else {
        ctx.strokeRect(c.x, c.y, c.width, c.height);
      }
      ctx.restore();
    }
  }
}





  // ===== Desktop Drag & Scale (Mouse) =====
function applyActiveDragDelta(dx, dy) {
  if (!activeDrag) return;
  if (isCircleBoxKey(activeDrag)) {
    var dragPos = getBoxXY(activeDrag);
    var cCircle = clampCircleTextPos(activeDrag, dragPos.x + dx, dragPos.y + dy);
    setBoxXY(activeDrag, cCircle.x, cCircle.y);
    return;
  }
  var pos = getBoxXY(activeDrag);
  var sc = getBoxScale(activeDrag);
  var c = clampFreeBoxPosByKey(activeDrag, pos.x + dx, pos.y + dy, sc);
  setBoxXY(activeDrag, c.x, c.y);
}

var documentDragBound = false;

function stopDocumentDrag() {
  if (!documentDragBound) return;
  document.removeEventListener('mousemove', onDocumentMouseDrag);
  document.removeEventListener('mouseup', onDocumentMouseDragEnd);
  document.removeEventListener('touchmove', onDocumentTouchDrag);
  document.removeEventListener('touchend', onDocumentTouchDragEnd);
  document.removeEventListener('touchcancel', onDocumentTouchDragEnd);
  documentDragBound = false;
}

function onDocumentMouseDrag(e) {
  if (!isDragging || !activeDrag || isPinching) return;
  var p = toCanvasXY(e.clientX, e.clientY);
  applyActiveDragDelta(p.x - dragStartX, p.y - dragStartY);
  dragStartX = p.x;
  dragStartY = p.y;
  updatePreview();
}

function onDocumentMouseDragEnd() {
  isDragging = false;
  activeDrag = null;
  stopDocumentDrag();
}

function onDocumentTouchDrag(e) {
  if (!isDragging || !activeDrag || isPinching) return;
  var t = null;
  for (var i = 0; i < e.touches.length; i++) {
    if (e.touches[i].identifier === firstTouchId) { t = e.touches[i]; break; }
  }
  if (!t) return;
  e.preventDefault();
  var p = toCanvasXY(t.clientX, t.clientY);
  applyActiveDragDelta(p.x - dragStartX, p.y - dragStartY);
  dragStartX = p.x;
  dragStartY = p.y;
  updatePreview();
}

function onDocumentTouchDragEnd(e) {
  if (e && e.changedTouches) {
    var ended = false;
    for (var i = 0; i < e.changedTouches.length; i++) {
      if (e.changedTouches[i].identifier === firstTouchId) ended = true;
    }
    if (!ended) return;
  }
  isDragging = false;
  activeDrag = null;
  stopDocumentDrag();
}

function startDocumentDrag() {
  stopDocumentDrag();
  document.addEventListener('mousemove', onDocumentMouseDrag);
  document.addEventListener('mouseup', onDocumentMouseDragEnd);
  document.addEventListener('touchmove', onDocumentTouchDrag, { passive: false });
  document.addEventListener('touchend', onDocumentTouchDragEnd);
  document.addEventListener('touchcancel', onDocumentTouchDragEnd);
  documentDragBound = true;
}

// MOUSE DOWN
previewCanvas.addEventListener('mousedown', function (e) {
  if (!isCanvasEditUnlocked()) return;
  const { x: mouseX, y: mouseY } = toCanvasXY(e.clientX, e.clientY);
  const hit = hitTestEditBox(mouseX, mouseY);

  if (!hit) {
    clearEditSelection();
    return;
  }
  if (selectedEditBox !== hit) {
    selectEditBox(hit);
    return;
  }

  activeDrag = hit;
  isDragging = true;
  dragStartX = mouseX;
  dragStartY = mouseY;
  startDocumentDrag();
});


// MOUSE MOVE (legacy — le drag actif est géré au niveau document)
previewCanvas.addEventListener('mousemove', function (e) {
  if (!isDragging || !activeDrag) return;
  onDocumentMouseDrag(e);
});

// MOUSE UP sur le canvas (backup si document raté)
previewCanvas.addEventListener('mouseup', onDocumentMouseDragEnd);

// WHEEL (zoom sur le box sélectionné)
previewCanvas.addEventListener('wheel', function (e) {
  if (!isCanvasEditUnlocked() || !selectedEditBox) return;
  if (Date.now() - lastEditBoxSelectAt < EDIT_WHEEL_GUARD_MS) return;
const { x: mouseX, y: mouseY } = toCanvasXY(e.clientX, e.clientY);
  if (hitTestEditBox(mouseX, mouseY) !== selectedEditBox) return;

function zoomBoxByKey(boxKey) {
  e.preventDefault();
  var sc = getBoxScale(boxKey);
  var maxSc = getMaxScaleForBox(boxKey);
  var minSc = getMinScaleFactorForBox(boxKey);
  var newScale = (e.deltaY < 0) ? sc * 1.05 : sc / 1.05;
  newScale = clampScale(newScale, minSc, maxSc, sc);
  var pos = getBoxXY(boxKey);
  var c = clampFreeBoxPosByKey(boxKey, pos.x, pos.y, newScale);
  setBoxXY(boxKey, c.x, c.y);
  setBoxScale(boxKey, newScale);
  updatePreview();
}

function zoomBox(isTwo) {
  zoomBoxByKey(isTwo ? 'box2' : 'box1');
}



  if (isCircleBoxKey(selectedEditBox)) {
    e.preventDefault();
    const minSc3 = getMinScaleFactorForBox(selectedEditBox);
    const maxSc3 = getMaxScaleForBox(selectedEditBox);
    var curSc = getBoxScale(selectedEditBox);
    let newScale = (e.deltaY < 0) ? curSc * 1.05 : curSc / 1.05;
    newScale = clampScale(newScale, minSc3, Math.max(minSc3, maxSc3), curSc);
    setBoxScale(selectedEditBox, newScale);
    updatePreview();
  } else if (selectedEditBox) {
    zoomBoxByKey(selectedEditBox);
  }
});






  
  // ===== Mobile Drag & Pinch (Touch) =====
// TOUCH START
previewCanvas.addEventListener('touchstart', function (e) {
  const rect = previewCanvas.getBoundingClientRect();

if (e.touches.length === 1) {
  if (!isPinching) {
    const p = toCanvasXY(e.touches[0].clientX, e.touches[0].clientY);
    const x = p.x, y = p.y;

    firstTouchId = e.touches[0].identifier;

    if (!isCanvasEditUnlocked()) {
      firstTouchOn = null;
      return;
    }

    const hit = hitTestEditBox(x, y);
    if (!hit) {
      clearEditSelection();
      firstTouchOn = null;
      return;
    }
    firstTouchOn = hit;
    if (selectedEditBox !== hit) {
      selectEditBox(hit);
      return;
    }
    pendingDragTarget = hit;
    activeDrag = hit;
    isDragging = true;
    dragStartX = x; dragStartY = y;
    startDocumentDrag();
  }
} else if (e.touches.length === 2) {
  if (!isCanvasEditUnlocked() || !selectedEditBox) return;
  e.preventDefault();

  // Retrouve le 1er doigt (pivot)
  const tA = e.touches[0], tB = e.touches[1];
  const firstTouch = (tA.identifier === firstTouchId) ? tA :
                     (tB.identifier === firstTouchId) ? tB : tA; // fallback
  const otherTouch = (firstTouch === tA) ? tB : tA;

  const pFirst = toCanvasXY(firstTouch.clientX, firstTouch.clientY);
  const pOther = toCanvasXY(otherTouch.clientX,  otherTouch.clientY);

  let target = selectedEditBox;
  if (hitTestEditBox(pFirst.x, pFirst.y) !== target && hitTestEditBox(pOther.x, pOther.y) !== target) {
    isPinching = false; pinchStart = null; return;
  }

  const avail1 = previewLogicalWidth - leftMargin  - rightMargin;
  const avail2 = previewLogicalWidth - leftMargin2 - rightMargin2;
  const availHt1 = previewLogicalHeight - topMargin - bottomMargin;
  const availHt2 = previewLogicalHeight - topMargin2 - bottomMargin2;
  const lineBlockH = maxTextHeight1;
  const lineBlockH2 = maxTextHeight2;
  const minSc3 = getMinScaleFactorForBox(target);
  const maxSc3 = getMaxScaleForBox(target);
  var pinchM = isCircleBoxKey(target) ? null : getBoxMargins(target);
  var pinchMaxSc = isCircleBoxKey(target)
    ? maxSc3
    : getMaxScaleForBox(target);

  pinchStart = {
    target,
    pivotX: pFirst.x,
    pivotY: pFirst.y,
    startScale: getBoxScale(target),
    startX: getBoxXY(target).x,
    startY: getBoxXY(target).y,
    minScale: getMinScaleFactorForBox(target),
    maxScale: pinchMaxSc,
    initDist: Math.hypot(pOther.x - pFirst.x, pOther.y - pFirst.y)
  };

  isPinching = true;
  isDragging = false;
}



}, { passive: false });

// TOUCH MOVE : si pas encore 1 s, annuler l'appui long (pour permettre le scroll)
previewCanvas.addEventListener('touchmove', function (e) {
  if ((isDragging || pinchStart) && !isCanvasEditUnlocked()) {
    resetCanvasInteraction();
    return;
  }
  if (e.touches.length === 1 && !isPinching) {
    if (pendingDragTarget && !activeDrag) {
      clearLongPress();
      return;
    }
  }
  if (e.touches.length === 1 && isDragging && !isPinching && activeDrag) {
    onDocumentTouchDrag(e);
  } else if (e.touches.length === 2 && pinchStart) {
  e.preventDefault();

  const tA = e.touches[0], tB = e.touches[1];
  // (peu importe lequel est le 1er maintenant : pivot est FIXE dans pinchStart)
  const p1 = toCanvasXY(tA.clientX, tA.clientY);
  const p2 = toCanvasXY(tB.clientX, tB.clientY);
  const dist = Math.hypot(p2.x - p1.x, p2.y - p1.y);

  // Nouveau scale relatif à l’état de départ
  let newScale = pinchStart.startScale * (dist / pinchStart.initDist);
  newScale = clampScale(newScale, pinchStart.minScale, pinchStart.maxScale, getBoxScale(pinchStart.target));

  const k = newScale / pinchStart.startScale;

  // Recalcule x/y autour du pivot FIXE
  let newX = pinchStart.pivotX + (pinchStart.startX - pinchStart.pivotX) * k;
  let newY = pinchStart.pivotY + (pinchStart.startY - pinchStart.pivotY) * k;

  // Clamps selon la cible
  const approxFont = initialFontSize * newScale;

  if (isCircleBoxKey(pinchStart.target)) {
    var cp3 = clampCircleTextPos(pinchStart.target, newX, newY);
    setBoxXY(pinchStart.target, cp3.x, cp3.y);
    setBoxScale(pinchStart.target, newScale);
  } else {
    var cp = clampFreeBoxPosByKey(pinchStart.target, newX, newY, newScale);
    setBoxXY(pinchStart.target, cp.x, cp.y);
    setBoxScale(pinchStart.target, newScale);
  }

  updatePreview();
}




}, { passive: false });

// TOUCH END
previewCanvas.addEventListener('touchend', function (e) {
  if (isDragging && activeDrag) {
    onDocumentTouchDragEnd(e);
  }
  if (e.touches.length === 0) {
    clearLongPress();
    isDragging = false;
    isPinching = false;
    activeDrag = null;
    firstTouchId = null;
    firstTouchOn = null;
    pinchStart = null;
  } else if (e.touches.length < 2) {
    isPinching = false;
    pinchStart = null;
  }
});







/** Regénère l’aperçu panier sur canvas propre (fetch blob) si le preview est tainted. */
function lcRebuildExportPreviewDataUrl() {
  var previewTexts = getPreviewTexts();
  var font = selectedFont;
  var color = selectedColor;
  var maskEl = document.getElementById('maskLayer');
  var maskSrc = maskEl && (maskEl.currentSrc || maskEl.src);

  return lcLoadImageViaBlob(getSelectedModelUrl()).then(function (modelPack) {
    var modelImage = modelPack.img;
    return resolveOrientedModelSize(modelImage).then(function (page) {
      var aspectRatio = page.width / page.height;
      var logicalW = PREVIEW_LOGICAL_WIDTH;
      var logicalH = PREVIEW_LOGICAL_WIDTH / aspectRatio;
      var scale = getPreviewPixelScale(page.width);
      var out = document.createElement('canvas');
      out.width = Math.round(logicalW * scale);
      out.height = Math.round(logicalH * scale);
      var ctx = out.getContext('2d');
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      ctx.imageSmoothingEnabled = true;
      if (ctx.imageSmoothingQuality) ctx.imageSmoothingQuality = 'high';
      ctx.clearRect(0, 0, logicalW, logicalH);
      page.draw(ctx, logicalW, logicalH);
      for (var clampIdx = 0; clampIdx < lcBoxCount; clampIdx++) {
        clampBoxScaleToTextFit('box' + (clampIdx + 1));
      }
      drawAllTextBoxes(ctx, previewTexts.text1, previewTexts.text2, font, color, true);
      return lcExportPreviewWithMaskBlob(out, maskSrc);
    }).finally(function () {
      URL.revokeObjectURL(modelPack.revoke);
    });
  }).catch(function () {
    return '';
  });
}

window.lcBuildLineItemProperties = buildLineItemProperties;
window.lcCartHasRequiredText = lcCartHasRequiredText;
window.lcNotifyCartTextRequired = lcNotifyCartTextRequired;
window.lcHiddenPropKey = lcHiddenPropKey;
window.LC_CART_PREVIEW_KEY = LC_CART_PREVIEW_KEY;
window.lcAttachCartPreview = lcAttachCartPreview;
window.lcCanvasWithMaskDataUrl = lcCanvasWithMaskDataUrl;
window.lcExportPreviewDataUrl = lcExportPreviewDataUrl;
window.lcExportPreviewDataUrlForUi = lcExportPreviewDataUrlForUi;
window.lcRebuildExportPreviewDataUrl = lcRebuildExportPreviewDataUrl;
window.lcWhenPreviewReadyForExport = lcWhenPreviewReadyForExport;
window.lcGenerateVectorPdfForUpload = lcGenerateVectorPdfForUpload;
window.lcCompressPreviewDataUrlForCart = lcCompressPreviewDataUrlForCart;
window.LC_CART_PREVIEW_MAX_CHARS = LC_CART_PREVIEW_MAX_CHARS;

var addToCartBtn = document.getElementById('addToCart');
if (addToCartBtn && !window.lcProductFormId) {
  addToCartBtn.addEventListener('click', function () {
    if (!lcCartHasRequiredText()) {
      lcNotifyCartTextRequired();
      return;
    }
    var variantId = 42103629512881;
    var qtyEl = (window.lcQuantityInputId && document.getElementById(window.lcQuantityInputId)) ||
      document.querySelector('.quantity-selector input[type="number"]');
    var quantity = parseInt(qtyEl && qtyEl.value, 10) || 1;
    var canvas = document.getElementById('previewCanvas');
    var props = buildLineItemProperties();
    if (typeof window.lcRunShopifyCartAdd === 'function') {
      window.lcRunShopifyCartAdd({
        variantId: variantId,
        quantity: quantity,
        props: props,
        canvas: canvas,
        addBtn: addToCartBtn
      });
      return;
    }
    Promise.resolve(canvas ? lcAttachCartPreview(props, canvas) : props).then(function (cartProps) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: cartProps }] })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) { console.log('Item added to cart:', data); })
        .catch(function (error) { console.error('Error adding item to cart:', error); });
    });
  });
}


(function lcBindQuantitySelector() {
  var root = document.querySelector('.lc-label-customizer .quantity-selector') ||
    document.querySelector('.quantity-selector');
  if (!root) return;
  var minus = root.querySelector('.quantity-button.minus');
  var plus = root.querySelector('.quantity-button.plus');
  var input = (window.lcQuantityInputId && document.getElementById(window.lcQuantityInputId)) ||
    root.querySelector('input[type="number"]');
  if (!minus || !plus || !input) return;
  minus.addEventListener('click', function () {
    var currentValue = parseInt(input.value, 10) || 1;
    if (currentValue > 1) input.value = String(currentValue - 1);
  });
  plus.addEventListener('click', function () {
    var currentValue = parseInt(input.value, 10) || 1;
    input.value = String(currentValue + 1);
  });
})();

// Tutoriel pas-à-pas (bulle sur le canvas)
var canvasEditCoachStep = null;
var canvasEditCoachTimer = null;

function isMobileEditor() {
  if (window.matchMedia('(pointer: coarse)').matches) return true;
  if (window.matchMedia('(hover: none)').matches) return true;
  if (window.innerWidth <= 768) return true;
  return false;
}

function canvasEditCoachMessage(step) {
  var mobile = isMobileEditor();
  if (step === 'pick') {
    return mobile
      ? lcStr('coachPickMobile', 'Touchez un encadré <span class="canvas-edit-coach__kw">vert</span> pour choisir une zone de texte')
      : lcStr('coachPickDesktop', 'Cliquez sur un encadré <span class="canvas-edit-coach__kw">vert</span> pour choisir une zone de texte');
  }
  return mobile
    ? lcStr('coachMoveMobile', 'Glissez d\'un doigt pour déplacer · Pincez à 2 doigts pour agrandir ou réduire')
    : lcStr('coachMoveDesktop', 'Glissez pour déplacer · Molette de la souris pour agrandir ou réduire');
}

function showCanvasEditCoach(step) {
  var el = document.getElementById('canvasEditCoach');
  if (!el) return;
  canvasEditCoachStep = step;
  el.hidden = false;
  el.dataset.step = step === 'pick' ? '1' : '2';
  el.dataset.device = isMobileEditor() ? 'mobile' : 'desktop';
  el.innerHTML = canvasEditCoachMessage(step);
}

function startCanvasEditCoach() {
  clearTimeout(canvasEditCoachTimer);
  showCanvasEditCoach('pick');
}

function advanceCanvasEditCoach() {
  if (canvasEditCoachStep !== 'pick') return;
  clearTimeout(canvasEditCoachTimer);
  showCanvasEditCoach('move');
  canvasEditCoachTimer = setTimeout(stopCanvasEditCoach, 5500);
}

function resetCanvasEditCoachOnDeselect() {
  if (!document.body.classList.contains('canvas-edit-mode')) return;
  if (canvasEditCoachStep === 'move') return;
  startCanvasEditCoach();
}

function stopCanvasEditCoach() {
  clearTimeout(canvasEditCoachTimer);
  canvasEditCoachStep = null;
  var el = document.getElementById('canvasEditCoach');
  if (el) {
    el.hidden = true;
    el.innerHTML = '';
  }
}

// Bouton × pour quitter le zoom
(function () {
  var btn = document.getElementById('canvasZoomClose');
  if (!btn) return;
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (selectedEditBox) clearEditSelection();
  });
})();

function setEditCanvasBtnState(isOn) {
  var btn = document.getElementById('editCanvasBtn');
  var resetBtn = document.getElementById('resetCanvasEditBtn');
  if (resetBtn) {
    resetBtn.hidden = !isOn;
    resetBtn.setAttribute('aria-hidden', isOn ? 'false' : 'true');
    if (!resetBtn.dataset.lcLabelBound) {
      resetBtn.dataset.lcLabelBound = '1';
      resetBtn.textContent = lcStr('resetCanvasEdit', 'Réinitialiser');
    }
  }
  if (!btn) return;
  btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
  var label = btn.querySelector('.edit-canvas-btn__label');
  var leading = btn.querySelector('.edit-canvas-btn__leading');
  var labelText = isOn
    ? lcStr('finishEdit', 'Terminer l\'édition')
    : lcStr('editCanvas', 'Éditer le canvas');
  if (label) {
    label.textContent = labelText;
  } else {
    btn.textContent = labelText;
  }
  if (leading) leading.hidden = isOn;
}

(function () {
  var resetBtn = document.getElementById('resetCanvasEditBtn');
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (!isCanvasEditUnlocked()) return;
      resetCanvasEditToPreset();
    });
  }
})();

// Bouton « Éditer le canvas » : déverrouille déplacement et scale
(function () {
  var btn = document.getElementById('editCanvasBtn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var on = document.body.classList.toggle('canvas-edit-mode');
    if (!on) {
      resetCanvasInteraction();
      clearEditSelection();
      stopCanvasEditCoach();
      exitCanvasEditMobile();
      updateCanvasZoomClose();
      var els = getPreviewCanvasElements();
      if (els.wrap) els.wrap.style.transform = '';
      if (els.viewport) els.viewport.style.height = '';
      updatePreview();
    } else {
      enterCanvasEditMobile();
      updatePreview();
      startCanvasEditCoach();
    }
    setEditCanvasBtnState(on);
  });
  window.addEventListener('resize', function () {
    if (selectedEditBox && isCanvasEditUnlocked()) updateEditViewport();
    if (canvasEditCoachStep) {
      var coach = document.getElementById('canvasEditCoach');
      if (coach && !coach.hidden) showCanvasEditCoach(canvasEditCoachStep);
    }
  });
})();

// Sur mobile : preview sticky + rétrécissement au scroll (scroll document unique)
(function () {
  var thresholdEnter = 56;
  var thresholdLeaveTop = 8;
  var shrinkLockUntil = 0;
  var scrollRaf = 0;
  var lastScrollY = 0;
  var leaveTopFrames = 0;

  function getLcAppRoot() {
    return document.querySelector('.lc-label-customizer.lc-app') || document.querySelector('.lc-app');
  }

  function useLcScopedShrunk() {
    return !!(window.lcProductFormId && getLcAppRoot());
  }

  function isPreviewShrunk() {
    if (useLcScopedShrunk()) {
      var root = getLcAppRoot();
      return !!(root && root.classList.contains('lc-preview-shrunk'));
    }
    return document.body.classList.contains('preview-shrunk');
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function isEditMode() {
    return document.body.classList.contains('canvas-edit-mode');
  }

  function setShrunk(on) {
    if (isEditMode()) on = false;
    if (useLcScopedShrunk()) {
      var root = getLcAppRoot();
      if (root) root.classList.toggle('lc-preview-shrunk', on);
    } else {
      document.documentElement.classList.toggle('preview-shrunk', on);
      document.body.classList.toggle('preview-shrunk', on);
    }
  }

  function previewColumnHeight() {
    var col = document.querySelector('.lc-preview-column');
    return col ? col.offsetHeight : 0;
  }

  function enterShrunk() {
    if (!isMobile() || isEditMode()) return;
    if (isPreviewShrunk()) return;
    var scrollBefore = scrollTopY();
    var hBefore = previewColumnHeight();
    setShrunk(true);
    leaveTopFrames = 0;
    shrinkLockUntil = Date.now() + 550;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var dh = hBefore - previewColumnHeight();
        if (dh <= 2) return;
        var target = scrollBefore - dh;
        if (target < thresholdEnter) target = thresholdEnter + 4;
        window.scrollTo(0, target);
        shrinkLockUntil = Date.now() + 400;
      });
    });
  }

  function leaveShrunk() {
    if (!isPreviewShrunk()) return;
    setShrunk(false);
    shrinkLockUntil = Date.now() + 200;
  }

  function scrollTopY() {
    var y = window.scrollY || window.pageYOffset || 0;
    if (!y && document.documentElement) y = document.documentElement.scrollTop || 0;
    if (!y && document.body) y = document.body.scrollTop || 0;
    var main = document.getElementById('MainContent');
    if (main) {
      var oy = window.getComputedStyle(main).overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && main.scrollHeight > main.clientHeight + 2) {
        y = Math.max(y, main.scrollTop || 0);
      }
    }
    return y;
  }

  function updateShrinkFromScroll() {
    if (isEditMode() && isMobile()) {
      if (scrollTopY() > 0) {
        window.scrollTo(0, 0);
      }
      return;
    }
    if (!isMobile()) {
      if (isPreviewShrunk()) leaveShrunk();
      return;
    }
    if (Date.now() < shrinkLockUntil) return;

    var y = scrollTopY();
    if (!isPreviewShrunk()) {
      leaveTopFrames = 0;
      if (y > thresholdEnter) enterShrunk();
      lastScrollY = y;
      return;
    }
    /* Réduit : regrandir seulement tout en haut ET en remontant (pas après layout shift) */
    if (y <= thresholdLeaveTop && y < lastScrollY - 1) {
      leaveTopFrames += 1;
      if (leaveTopFrames >= 2) leaveShrunk();
    } else if (y > thresholdLeaveTop + 12) {
      leaveTopFrames = 0;
    } else if (y <= thresholdLeaveTop && lastScrollY <= thresholdLeaveTop) {
      leaveTopFrames += 1;
      if (leaveTopFrames >= 4) leaveShrunk();
    } else {
      leaveTopFrames = 0;
    }
    lastScrollY = y;
  }

  function onWindowScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      updateShrinkFromScroll();
    });
  }

  window.enterCanvasEditMobile = function () {
    if (!isMobile()) return;
    window.scrollTo(0, 0);
    leaveShrunk();
    document.documentElement.classList.add('canvas-edit-scroll-lock');
    document.body.classList.add('canvas-edit-scroll-lock');
  };

  window.exitCanvasEditMobile = function () {
    if (!isMobile()) return;
    document.documentElement.classList.remove('canvas-edit-scroll-lock');
    document.body.classList.remove('canvas-edit-scroll-lock');
    requestAnimationFrame(updateShrinkFromScroll);
  };

  function bindScrollShrink() {
    window.addEventListener('scroll', onWindowScroll, { passive: true });
    var mainContent = document.getElementById('MainContent');
    if (mainContent) mainContent.addEventListener('scroll', onWindowScroll, { passive: true });
  }
  window.lcEnterPreviewShrunk = enterShrunk;
  window.lcLeavePreviewShrunk = leaveShrunk;

  bindScrollShrink();
  lastScrollY = scrollTopY();
  requestAnimationFrame(updateShrinkFromScroll);
  window.addEventListener('load', updateShrinkFromScroll);
  window.addEventListener('resize', function () {
    if (!isMobile()) leaveShrunk();
    if (isEditMode() && isMobile()) enterCanvasEditMobile();
    updateShrinkFromScroll();
  });
})();

// Dropdowns : en mobile, rétrécir le preview si on n'est pas en haut de page
(function () {
  var minHeightForFull = 420;
  function atTopAndEnoughSpace() {
    if (window.innerWidth > 768) return true;
    if (document.body.classList.contains('canvas-edit-mode')) return true;
    if (window.innerHeight < minHeightForFull) return false;
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    return y <= 36;
  }
  document.querySelectorAll('.dropdown-header').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = this.closest('.dropdown-section');
      if (!section) return;
      section.classList.toggle('collapsed');
      var expanded = !section.classList.contains('collapsed');
      this.setAttribute('aria-expanded', expanded);
      if (expanded && section.getAttribute('data-section') === 'style' && typeof window.lcPaintColorSwatches === 'function') {
        window.lcPaintColorSwatches();
      }
      if (window.innerWidth > 768) return;
      if (expanded && !atTopAndEnoughSpace()) {
        if (typeof window.lcEnterPreviewShrunk === 'function') window.lcEnterPreviewShrunk();
      } else if (!expanded && atTopAndEnoughSpace()) {
        if (typeof window.lcLeavePreviewShrunk === 'function') window.lcLeavePreviewShrunk();
      }
    });
  });
})();

var downloadPdfBtn = document.getElementById('downloadPDF');
if (downloadPdfBtn) downloadPdfBtn.addEventListener('click', function () {
  var downloadBtn = downloadPdfBtn;
  downloadBtn.disabled = true;

  function finishPdf() {
    if (downloadBtn) downloadBtn.disabled = false;
  }

  if (!previewReadyForPdf || !previewLogicalWidth || !previewLogicalHeight ||
      previewLogicalHeight === PREVIEW_LOGICAL_WIDTH && modelNativeWidth === 0) {
    alert(lcStr('previewLoading', 'Le preview est en cours de chargement. Réessayez dans un instant.'));
    finishPdf();
    return;
  }

  var fontPath = lcGetPdfCustomFontPaths()[selectedFont];
  (fontPath ? lcLoadFontBase64ForPdf(fontPath) : Promise.resolve(null))
    .catch(function (err) {
      console.error('Error loading font for PDF:', err);
      return null;
    })
    .then(function (fontBase64) {
      return generateVectorPdf(fontBase64);
    })
    .catch(function (err) {
      console.error('PDF generation failed:', err);
      alert(lcStr('pdfError', 'Impossible de générer le PDF. Vérifiez que l\'image du modèle est bien chargée.'));
    })
    .then(finishPdf);
});
















});



